import { ErrorResponse, StockTypeDropDown, StockTypeStatus } from '@gtpl/shared-models/common-models';
import { LocationRequest, OccupancyEnum, RackAckResponse, RackDto, RackModel, RackPositionId, RackPositionModel, RackPositionResponseModel, RackResponseModel, RackSuggestionResponseDto } from '@gtpl/shared-models/masters';
import { CommonResponse } from '@gtpl/shared-models/warehouse-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { getManager, Not, Repository } from 'typeorm';
import { RackDTONew } from './dto/rack.dto';
import { Rack } from '../racks/racks.entity';
import { PlantIdRequest } from '../unit-codes/dto/plant-id.request';
import { ZoneMaster } from '../zone-master/zone-master.entity';
import { RackPosition } from './rack-position.entity';
import { RackPostionRequest } from './dto/rack-position.request';
import { RackIdRequest } from './dto/rack-id-request';
import { PlantRackPosRequest } from './dto/plant-rack-pos.request';
import { RackPostionReq } from './dto/rack-position-request';
import { RackSuggestionRequest } from './dto/rack-suggestion-request';
import { appSettings } from './../../../../config';
import { SaleOrderService } from '@gtpl/shared-services/sale-management';
import { PackingMethodService, RackService, ZoneService } from '@gtpl/shared-services/masters';
import { LocationsRequest } from './dto/locations.request';
import { FgStockStatusEnum, RackReserveRequest, RackSuggestionDto } from '@gtpl/shared-models/warehouse-management';
import { RackPositionIdRequest } from './dto/rack-position-id.request';
import { RackZoneLevelRequest } from './dto/zone-rack-level.request';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';

import { ZoneIdRequest } from './dto/zone-id.request';
import { SoIdRequest } from './dto/so-id.request';
import { ZoneRackIdRequest } from './dto/zone-rack-id.request';
import { FGStockService } from '@gtpl/shared-services/warehouse-management';
import { RackStatusRequest } from './dto/rack-status.request';
import { DummyRackRequest } from './dto/dummy-rack.request';
import { ReservedRacksSoRequest } from './dto/reserved-racks-so.request';
import { StockTransferDto } from './dto/update-rackposition.request';
import { ReserveRacksPostionsRequest } from './dto/reserve-racks-positions.request';
import { RackSuggestionRequestDto } from './dto/rack-suggestion.request.dto';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { saleOrderItemIdRequest } from '@gtpl/shared-models/sale-management';
import { InternalTransferDto } from './dto/internal-transfer-dto';
@Injectable()
export class RackPositionService {
    constructor(
      private logService:LogsService,

        @InjectRepository(RackPosition) private rackRepository: Repository<RackPosition>,
        private packingMethodService: PackingMethodService,
        private saleOrderService: SaleOrderService,
        private fGStockService: FGStockService,
        private zoneMasterService: ZoneService,
        private rackService: RackService
    ) { }

    /**
     * Service to create new rack
     * @param rackDto 
     * @returns 
     */
    async createRackPosition(rackDto: RackDTONew): Promise<RackAckResponse> {
        const rackResult = await this.validateRackExistsOrNot(rackDto.rackPositionCode);
        if (rackResult) {
            throw new ErrorResponse(10000, 'Rack already exists');
        } else {
            console.log(rackDto);
            console.log(rackDto.rackPositionCode.split(/([0-9]+)/));
            console.log(rackDto.rackPositionCode.split(/([0-9]+)/)[0]);
            console.log(rackDto.rackPositionCode.split(/([0-9]+)/)[1]);
            const rackEntity = new RackPosition();
            rackEntity.rackMasterInfo = new Rack();
            rackEntity.rackMasterInfo.rackId = rackDto.rackMasterId;
            rackEntity.rackCode = rackDto.rackPositionCode;
            rackEntity.rackPosition = rackDto.rackPosition;
            rackEntity.rackLevel = rackDto.rackLevel;
            rackEntity.rackColumn = Number(rackDto.rackPositionCode.split(/([0-9]+)/)[1]);
            rackEntity.rackBoundaries = rackDto.rackBoundaries;
            rackEntity.rackPositionType = rackDto.rackPositionType;
            rackEntity.assocRfId = rackDto.assocRfId;
            rackEntity.plantId = rackDto.plantId;
            rackEntity.createdUser = rackDto.createdUser;
            if (rackDto.occupancy) {
                rackEntity.occupancy = rackDto.occupancy;
            }
            const rackResponse = await this.rackRepository.save(rackEntity);
            if (rackResponse) {
                const respo = new RackAckResponse(true, 10000, 'Rack Details Created Successfully');
                const newLogDto = new LogsDto(1,'created', 'RackPosition', rackResponse.rackPositionId, true, '',rackResponse.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return respo
            }
        }
    }

    /**
     * validate if a rack is existed or not
     * @param rackCode
     * @returns boolean true/false
     */
    async validateRackExistsOrNot(rackCode: string): Promise<boolean> {
        const rackResponse = await this.rackRepository.findOne({
            where: { rackCode: rackCode },
        });
        if (rackResponse) {
            return true;
        } else {
            return false;
        }
    }

    /**
     * Service to update a rack details
     * @param rackDto 
     * @returns 
     */
    async updateRackPosition(rackDto: RackDTONew): Promise<RackAckResponse> {
        const rackEntity = await this.rackRepository.findOne({
            where: { rackCode: rackDto.rackPositionCode },
        });
        if (!rackEntity) {
            throw new ErrorResponse(10000, 'Rack details not found');
        } else {
            console.log(rackDto);
            console.log(rackDto.rackPositionCode.split(/([0-9]+)/));
            console.log(rackDto.rackPositionCode.split(/([0-9]+)/)[0]);
            console.log(rackDto.rackPositionCode.split(/([0-9]+)/)[1]);
            rackEntity.rackMasterInfo = new Rack();
            rackEntity.rackMasterInfo.rackId = rackDto.rackMasterId;
            rackEntity.rackCode = rackDto.rackPositionCode;
            rackEntity.rackPosition = rackDto.rackPosition;
            rackEntity.rackLevel = rackDto.rackLevel;
            rackEntity.rackColumn = Number(rackDto.rackPositionCode.split(/([0-9]+)/)[1]);
            rackEntity.rackBoundaries = rackDto.rackBoundaries;
            rackEntity.rackPositionType = rackDto.rackPositionType;
            rackEntity.assocRfId = rackDto.assocRfId;
            rackEntity.plantId = rackDto.plantId;
            rackEntity.updatedUser = rackDto.updatedUser;
            if (rackDto.occupancy) {
                rackEntity.occupancy = rackDto.occupancy;
            }
            const rackResponse = await this.rackRepository.save(rackEntity);
            if (rackResponse) {
                const respp = new RackAckResponse(true, 10000, 'Rack Details Updated Successfully');
                const newLogDto = new LogsDto(1,'updated', 'RackPosition', rackResponse.rackPositionId, true, '',rackResponse.createdUser)
                let res = await this.logService.createLog(newLogDto);
                console.log(res);
                return respp
            }
        }
    }

    /**
     * Service to get all the racks
     * @returns 
     */
    async getAllRacksPositions(): Promise<RackAckResponse> {
        const racksResponse = await this.rackRepository.find({
            relations: ["rackMasterInfo"],
            order: { rackId: "ASC" },
        });

        const rackDetails: RackModel[] = [];
        if (racksResponse.length === 0) {
            throw new ErrorResponse(9999, 'Rack details not found');
        }
        for (const rack of racksResponse) {
            const rackModel = new RackModel(rack.rackPositionId, rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.createdAt, rack.updatedAt, rack.isActive, rack.versionFlag, rack.rackMasterInfo.rackId, rack.rackMasterInfo.rackName, rack.rackMasterInfo.rackCode, rack.rackPositionType);
            rackDetails.push(rackModel);
        }
        const resp=new RackAckResponse(true, 10000, 'Rack Details Retrived Successfully', rackDetails);
        const newLogDto = new LogsDto(1,'view', 'RackPosition', 0, true, '','')
        let res = await this.logService.createLog(newLogDto);
        console.log(res);
        return resp;
    }

    /**
     * Service to get all the racks by plant id
     * @param plantIdReq
     * @returns 
     */
    async getAllRacksByPlantId(plantIdReq: PlantIdRequest): Promise<RackAckResponse> {
        const racksResponse = await this.rackRepository.find({
            relations: ["rackMasterInfo"],
            where: { plantId: plantIdReq.plantId },
            order: { rackId: "ASC" },
        });

        const rackDetails: RackModel[] = [];
        if (racksResponse.length === 0) {
            throw new ErrorResponse(9999, 'Rack details not found');
        }
        for (const rack of racksResponse) {
            const rackModel = new RackModel(rack.rackPositionId, rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.createdAt, rack.updatedAt, rack.isActive, rack.versionFlag, rack.rackMasterInfo.rackId, rack.rackMasterInfo.rackName, rack.rackMasterInfo.rackCode);
            rackDetails.push(rackModel);
        }
        return new RackAckResponse(true, 10000, 'Rack Details Retrived Successfully', rackDetails);
    }

    /**
     * 
     * @param rackReq 
     * @returns 
     */
    async activateOrDeactivateRack(rackReq: any): Promise<RackAckResponse> {
        const rackExists = await this.rackRepository.findOne({
            where: { rackPositionId: rackReq.rackId },
        });
        if (rackExists) {
            if (rackReq.versionFlag !== rackExists.versionFlag) {
                throw new ErrorResponse(10113, 'Someone updated the current Rack information.Refresh and try again');
            } else {
                const rackStatus = await this.rackRepository.update(
                    { rackPositionId: rackReq.rackId },
                    { isActive: rackReq.isActive, updatedUser: rackReq.updatedUser });

                if (rackExists.isActive) {
                    if (rackStatus.affected) {
                        const rackResponse = new RackAckResponse(true, 10115, 'Rack is de-activated successfully');
                        return rackResponse;
                    } else {
                        throw new ErrorResponse(10111, 'Rack is already deactivated');
                    }
                } else {
                    if (rackStatus.affected) {
                        const rackResponse = new RackAckResponse(true, 10114, 'Rack is activated successfully');
                        return rackResponse;
                    } else {
                        throw new ErrorResponse(10112, 'Rack is already  activated');
                    }
                }
            }
        } else {
            throw new ErrorResponse(99998, 'No Records Found');
        }
    }
    async getRacksForRackId(rackPostionRequest: RackIdRequest): Promise<RackPositionResponseModel> {
        const data: RackPositionModel[] = []
        const racksResponse = await this.rackRepository.find({
            relations: ["rackMasterInfo"],
            where: { rackId: rackPostionRequest.rackId, occupancy: OccupancyEnum.NOT_OCCUPIED },
            order: { rackPositionType: "DESC" },

        });
        console.log('racksResponse' + racksResponse);
        if (racksResponse.length > 0) {
            racksResponse.forEach(rack => {
                const rackModel = new RackPositionModel(rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.rackId, rack.isActive, rack.rackPositionId, rack.rackMasterInfo.rackName, rack.rackMasterInfo.rackCode);
                data.push(rackModel);
            });
            return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
        }
        else {
            return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
        }

    }


    async getRacksForZoneId(rackPostionRequest: ZoneIdRequest): Promise<RackPositionResponseModel> {
        const data: RackPositionModel[] = []
        const racksResponse = await this.rackRepository.find({
            relations: ["rackMasterInfo"],
            where: { zoneId: rackPostionRequest.zoneId, occupancy: OccupancyEnum.NOT_OCCUPIED },
            order: { rackId: "ASC", rackPositionType: "DESC" },
        });
        console.log('racksResponse' + racksResponse);
        if (racksResponse.length > 0) {
            racksResponse.forEach(rack => {
                const rackModel = new RackPositionModel(rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.rackId, rack.isActive, rack.rackPositionId, rack.rackMasterInfo.rackName, rack.rackMasterInfo.rackCode);
                data.push(rackModel);
            });
            return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
        }
        else {
            return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
        }

    }
    async getAvailableRackPositionsForZoneId(rackPostionRequest: ZoneRackIdRequest): Promise<RackPositionResponseModel> {
        const data: RackPositionModel[] = []
        let racksResponse;
        if (rackPostionRequest.plantId == 2) {
            racksResponse = await this.rackRepository.find({
                relations: ["rackMasterInfo"],
                where: { zoneId: rackPostionRequest.zoneId, rackId: rackPostionRequest.rackId, isActive: true },
                order: { rackPositionCode: "ASC" },

            });
            if (racksResponse.length > 0) {
                racksResponse.forEach(rack => {
                    const rackModel = new RackPositionModel(rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.rackId, rack.isActive,rack.rackMasterInfo.rackId,rack.rackMasterInfo.rackName, rack.rackMasterInfo.rackCode,rack.rackPositionId,0);
                    data.push(rackModel);
                });
                return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
            }
            else {
                return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
            }
        }
        else {
            const connection = getManager();
            let query = "SELECT rp.rack_code AS rackCode,rp.plant_id AS plantId, rp.assoc_rfid AS assocRfId, rp.rack_position AS rackPosition,rp.rack_level AS rackLevel, rp.rack_boundaries AS rackBoundaries , rp.occupancy AS occupancy, rp.rack_id AS rackId, rp.is_active AS isActive, rack_position_id AS rackPositionId, r.rack_id AS rackMasterId, r.rack_name AS rackMasterName from "+appSettings.masters_db+".rack_position rp LEFT JOIN "+appSettings.masters_db+".rack r on r.rack_id = rp.rack_id where rp.zone_id ="+rackPostionRequest.zoneId+" and rp.rack_id ="+rackPostionRequest.rackId+" and rp.is_active = true and rp.sale_order_id IN (0,"+rackPostionRequest.saleOrderId+") ORDER BY rack_position_code ASC";
            racksResponse = await connection.query(query);
            // racksResponse = await this.rackRepository.find({
            //     relations:["rackMasterInfo"],
            //     where: {zoneId: rackPostionRequest.zoneId, rackId:rackPostionRequest.rackId,
            //         // occupancy: 'Not occupied', isReserved:false, 
            //         isActive:true},
            //     order:{rackPositionCode:"ASC"},
                
            // });
            if (racksResponse.length > 0) {
                racksResponse.forEach(rack => {
                    const rackModel = new RackPositionModel(rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.rackId, rack.isActive, rack.rackMasterId, rack.rackMasterName,"", rack.rackPositionId);
                    data.push(rackModel);
                });
                return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
            }
            else {
                return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
            }
        }
        console.log('racksResponse' + racksResponse);
        console.log('racksResponse' + racksResponse.length);

        

    }
    async getAvailableRackPositionsForInternalTransfer(req: InternalTransferDto): Promise<RackPositionResponseModel> {
        const connection = getManager();
        const data: RackPositionModel[] = []
        let racksResponse;
        let partialRackPositions;
        let partialRackPositionsResult;
        if (req.plantId == 2) {
            racksResponse = await this.rackRepository.find({
                relations: ["rackMasterInfo"],
                where: { zoneId: req.zoneId, rackId: req.rackId, isActive: true },
                order: { rackPositionCode: "ASC" },

            });
        }
        else {
            racksResponse = await this.rackRepository.find({
                relations:["rackMasterInfo"],
                where: {zoneId: req.zoneId, rackId:req.rackId,occupancy: 'Not occupied', isReserved:false, isActive:true},
                order:{rackPositionCode:"ASC"},
                
            });
            partialRackPositions = "Select rpp.rack_position_id AS rackPositionId, rpp.rack_code AS rackCode from "+appSettings.warehouse_db+".stock s left join "+appSettings.masters_db+"rack_position rpp on rpp.rack_position_id = s.location where s.location IN (Select GROUP_CONCAT(rack_position_id) from "+appSettings.masters_db+".rack_position rp where zone_id ="+req.zoneId+" and rack_id="+req.rackId+") and s.sale_order_id ="+req.saleOrderId+" and status = 'StockIn' and state = 'Stock'";
            partialRackPositionsResult = await connection.query(partialRackPositions);
            let newResponse = [...racksResponse, ...partialRackPositionsResult];
            console.log(newResponse);

        }
        console.log('racksResponse' + racksResponse);
        if (racksResponse.length > 0) {
            racksResponse.forEach(rack => {
                const rackModel = new RackPositionModel(rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.rackId, rack.isActive, rack.rackPositionId, rack.rackMasterInfo.rackName, rack.rackMasterInfo.rackCode);
                data.push(rackModel);
            });
            return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
        }
        else {
            return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
        }

    }
    async getAvailableRackPositionsForPlantId(req: RackSuggestionRequest): Promise<RackPositionResponseModel> {
        // console.log("req"+req);
        // console.log("mastersCartons"+req.mastersCartons);

        if(String(req.mastersCartons) === ''){
            req.mastersCartons=0;
        }
        const connection = getManager();
        const data: RackPositionModel[] = []
        if (req.plantId === 2) {
            console.log("HIII")
            const getRackPositions = 'select rack_code AS rackCode, plant_id AS plantId, assoc_rfid AS assocRfid, rack_position AS rackPosition, rack_level AS rackLevel, rack_boundaries AS rackBoundaries, rack_id AS rackId, is_active AS isActive, rack_position_id AS rackPositionId,rack_code AS rackCode, occupancy AS occupancy, 0 AS maxPalletCapacity from '+appSettings.masters_db+'.rack_position where plant_id = '+req.plantId+' and is_active=true';
            const rackPositionCodes = await connection.query(getRackPositions);
            if(rackPositionCodes.length>0){
                rackPositionCodes.forEach(rack => {
                    const rackModel = new RackPositionModel(rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.rackId, rack.isActive, rack.rackPositionId, rack.rackCode, rack.rackCode, rack.rackPositionId);
                    data.push(rackModel);
                });
                return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
            }
            else {
                return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
            }
        }
        else if(req.stockTypeStatus === "dummy" || req.stockTypeStatus === "superDummy"){
            // console.log("Hello")

            const getRackPositions = 'select rack_code AS rackCode, plant_id AS plantId, assoc_rfid AS assocRfid, rack_position AS rackPosition, rack_level AS rackLevel, rack_boundaries AS rackBoundaries, rack_id AS rackId, is_active AS isActive, rack_position_id AS rackPositionId,rack_code AS rackCode, occupancy AS occupancy,0 AS maxPalletCapacity from '+appSettings.masters_db+'.rack_position where plant_id = '+req.plantId+' and occupancy = "'+OccupancyEnum.NOT_OCCUPIED+'" and is_reserved=false and is_active=true';
            const rackPositionCodes = await connection.query(getRackPositions);
            // console.log(rackPositionCodes);
            data.push.apply(data, rackPositionCodes);
            let getPartialRackPositions;
            if(req.stockTypeStatus === "superDummy" && req.packStyleId != undefined){
                getPartialRackPositions = 'SELECT r.rack_code AS rackCode, r.plant_id AS plantId, r.assoc_rfid AS assocRfid, r.rack_position AS rackPosition, r.rack_level AS rackLevel, r.rack_boundaries AS rackBoundaries, r.rack_id AS rackId, r.is_active AS isActive, r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,pm.pallet_capacity, IF(MAX(pm.max_pallet_capacity) > pms.max_pallet_capacity,MAX(pm.max_pallet_capacity),pms.max_pallet_capacity) AS maxPalletCapacity FROM '+appSettings.warehouse_db+'.stock s LEFT JOIN '+appSettings.sales_db+'.sale_order_items si ON si.sale_order_item_id = s.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.`packing_methods` pms ON pms.packing_method_id = '+req.packStyleId+' LEFT JOIN '+appSettings.masters_db+'.`packing_methods` pm ON pm.packing_method_id = s.pack_style_id LEFT JOIN '+appSettings.masters_db+'.rack_position r on r.rack_position_id = s.location WHERE unit_id = '+req.plantId+' and STATUS = "StockIn" GROUP BY location Having SUM(total_cartons)<maxPalletCapacity and (maxPalletCapacity-SUM(total_cartons))>='+req.mastersCartons;
            }
            else if(req.stockTypeStatus != "superDummy"){
                getPartialRackPositions = "SELECT IF(spm.max_pallet_capacity > MAX(pm.max_pallet_capacity), spm.max_pallet_capacity,MAX(pm.max_pallet_capacity)) AS maxPalletCapacity,rp.rack_code AS rackCode, rp.plant_id AS plantId, rp.assoc_rfid AS assocRfid, rp.rack_position AS rackPosition, rp.rack_level AS rackLevel, rp.rack_boundaries AS rackBoundaries, rp.rack_id AS rackId, rp.is_active AS isActive, rp.rack_position_id AS rackPositionId,rp.rack_code AS rackCode, rp.occupancy AS occupancy FROM erpx_dev_warehouse.stock s LEFT JOIN erpx_dev_masters.rack_position rp ON rp.rack_position_id = s.location LEFT JOIN erpx_dev_masters.packing_methods pm ON pm.packing_method_id = s.pack_style_id LEFT JOIN erpx_dev_masters.packing_methods spm ON spm.packing_method_id = "+req.packStyleId+" WHERE s.unit_id = "+req.plantId+" and s.sale_order_id = "+req.saleOrderId+" AND s.status = 'stockIn' GROUP BY s.location HAVING (maxPalletCapacity - SUM(s.total_cartons)) > 0 AND (maxPalletCapacity - SUM(s.total_cartons)) >= "+req.mastersCartons+" ORDER BY rp.rack_code";
                // let packStyle = await connection.query(highestPalletCapacity);
                // console.log("packStyle");
                // console.log(packStyle);
                // getPartialRackPositions = 'SELECT r.rack_code AS rackCode, r.plant_id AS plantId, r.assoc_rfid AS assocRfid, r.rack_position AS rackPosition, r.rack_level AS rackLevel, r.rack_boundaries AS rackBoundaries, r.rack_id AS rackId, r.is_active AS isActive, r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,pm.pallet_capacity, pm.max_pallet_capacity FROM '+appSettings.warehouse_db+'.stock s LEFT JOIN '+appSettings.sales_db+'.sale_order_items si ON si.sale_order_item_id = s.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.packing_methods spm ON spm.packing_method_id = s.pack_style_id LEFT JOIN '+appSettings.masters_db+'.`packing_methods` pm ON pm.packing_method_id = '+req.packStyleId+' LEFT JOIN '+appSettings.masters_db+'.rack_position r on r.rack_position_id = s.location WHERE unit_id = '+req.plantId+' and STATUS = "StockIn" GROUP BY location Having SUM(total_cartons)<pm.max_pallet_capacity and (pm.max_pallet_capacity-SUM(total_cartons))>='+req.mastersCartons;
            }
            else {
                return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
            }
            const stockLocations = await connection.query(getPartialRackPositions);
            console.log(stockLocations);
            data.push.apply(data, stockLocations);
            console.log(data);

            if (data.length > 0) {
                return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
            }
            else {
                return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
            }
        }
        else if (req.stockTypeStatus === "SaleOrder" || req.stockTypeStatus === "anticipated") {

            console.log("Hello")

            const getRackPositions = 'select rack_code AS rackCode, plant_id AS plantId, assoc_rfid AS assocRfid, rack_position AS rackPosition, rack_level AS rackLevel, rack_boundaries AS rackBoundaries, rack_id AS rackId, is_active AS isActive, rack_position_id AS rackPositionId,rack_code AS rackCode, occupancy AS occupancy,0 AS maxPalletCapacity from '+appSettings.masters_db+'.rack_position where plant_id = '+req.plantId+' and occupancy = "'+OccupancyEnum.NOT_OCCUPIED+'" and is_reserved=false and is_active=true';
            const rackPositionCodes = await connection.query(getRackPositions);
            console.log(rackPositionCodes);
            data.push.apply(data, rackPositionCodes);
            const getPartialRackPositions = 'SELECT r.rack_code AS rackCode, r.plant_id AS plantId, r.assoc_rfid AS assocRfid, r.rack_position AS rackPosition, r.rack_level AS rackLevel, r.rack_boundaries AS rackBoundaries, r.rack_id AS rackId, r.is_active AS isActive, r.rack_position_id AS rackPositionId,r.rack_code AS rackCode,r.occupancy AS occupancy,pm.pallet_capacity, pm.max_pallet_capacity AS palletCapacity FROM '+appSettings.warehouse_db+'.stock s LEFT JOIN '+appSettings.sales_db+'.sale_order_items si ON si.sale_order_item_id = s.sale_order_item_id LEFT JOIN '+appSettings.masters_db+'.`packing_methods` pm ON pm.packing_method_id = si.pack_style_id LEFT JOIN '+appSettings.masters_db+'.rack_position r on r.rack_position_id = s.location WHERE unit_id = '+req.plantId+' and s.sale_order_item_id = '+req.saleOrderItemId+' and STATUS = "StockIn" GROUP BY location Having SUM(total_cartons)<pm.pallet_capacity and (pm.pallet_capacity-SUM(total_cartons))>='+req.mastersCartons;
            const stockLocations = await connection.query(getPartialRackPositions);
            console.log(stockLocations);
            data.push.apply(data, stockLocations);
            console.log(data);

            if (data.length > 0) {
                return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
            }
            else {
                return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
            }
        }         
    }
    async getReservedRackPositionsForSO(reservedRacksSoRequest: ReservedRacksSoRequest): Promise<RackPositionResponseModel> {
        const data: RackPositionModel[] = []
        const racksResponse = await this.rackRepository.find({
            relations: ["rackMasterInfo"],
            where: { rackId: reservedRacksSoRequest.rackId, occupancy: OccupancyEnum.OCCUPIED, isReserved: true, isActive: true, saleOrderId: reservedRacksSoRequest.saleOrderId },
            order: { rackPositionCode: "ASC" },

        });
        console.log('racksResponse' + racksResponse);
        if (racksResponse.length > 0) {
            racksResponse.forEach(rack => {

                const rackModel = new RackPositionModel(rack.rackCode, rack.plantId, rack.assocRfId, rack.rackPosition, rack.rackLevel, rack.rackBoundaries, rack.occupancy, rack.rackId, rack.isActive, rack.rackPositionId, rack.rackMasterInfo.rackName, rack.rackMasterInfo.rackCode);
                data.push(rackModel);
            });
            return new RackPositionResponseModel(true, 10000, 'Rack Details Retrived Successfully', data);
        }
        else {
            return new RackPositionResponseModel(false, 10000, 'Rack Details not found');
        }

    }


    async updateRackPostionOccupancy(rackPostionRequest: RackIdRequest): Promise<CommonResponse> {
        const racksResponse = await this.rackRepository.update({ rackPositionId: rackPostionRequest.rackId }, { occupancy: OccupancyEnum.ASSIGNED, isReserved: true, saleOrderId: rackPostionRequest.saleOrderId })
        if (racksResponse) {
            return new CommonResponse(true, 1001, 'rack position assigned succesfully. ', racksResponse.affected)
        }
        else {
            return new CommonResponse(false, 10000, 'Rack Details not found', racksResponse.affected);
        }
    }

    async updateRackPostionOccupancyNotOccupied(rackPostionRequest: RackIdRequest): Promise<CommonResponse> {
        const racksResponse = await this.rackRepository.update({rackPositionId:rackPostionRequest.rackId},{occupancy:OccupancyEnum.NOT_OCCUPIED,isReserved:false,saleOrderId:0})
        if(racksResponse){
            return new CommonResponse(true,1001,'rack position assigned succesfully. ', racksResponse.affected)
        }
        else{
            return new CommonResponse(false, 10000, 'Rack Details not found', racksResponse.affected);     
        }
          
    }

    async getRackPositionsForRackMasterId(rackPostionRequest: RackIdRequest): Promise<RackResponseModel> {
        const racksResponse = await this.rackRepository.findOne({
            where: { rackPositionId: rackPostionRequest.rackId, occupancy: Not(OccupancyEnum.OCCUPIED) },
            order: { rackPositionType: 'DESC' }
        });
        console.log(racksResponse);
        const rackModel = new RackDto(racksResponse.rackPositionId, racksResponse.rackCode, racksResponse.rackCode, 0,
            racksResponse.zoneId, "", racksResponse.createdUser, racksResponse.isActive, racksResponse.versionFlag);
        return new RackResponseModel(true, 10000, 'Rack Details Retrived Successfully', rackModel);
    }

    async getEpcForRackPosition(plantRackPosReq: PlantRackPosRequest): Promise<CommonResponse> {
        const rackPosResponse = await this.rackRepository.findOne({
            select: ["assocRfId"],
            where: { plantId: plantRackPosReq.plantId, rackCode: plantRackPosReq.rackPositionCode },
        });
        if (!rackPosResponse) {
            throw new ErrorResponse(10000, 'Rack Position details not found');
        } else {
            return new CommonResponse(true, 10000, 'Rack Position details found', rackPosResponse.assocRfId);
        }
    }

    async freeRackPostionOccupancy(rackPostionRequest: RackIdRequest): Promise<CommonResponse> {
        const racksResponse = await this.rackRepository.update({ rackPositionId: rackPostionRequest.rackId }, { occupancy: OccupancyEnum.NOT_OCCUPIED, isReserved: false, saleOrderId: 0 })
        if (racksResponse) {
            return new CommonResponse(true, 1001, 'rack position cleared succesfully. ', racksResponse.affected)
        }
        else {
            return new CommonResponse(false, 10000, 'Rack Details not found', racksResponse.affected);
        }

    }
    async updateRackStatus(rackPostionRequest: StockTransferDto): Promise<boolean> {
        console.log(rackPostionRequest.selectedRows)
        let flag
        for (const res of rackPostionRequest.selectedRows) {
            const racksResponse = await this.rackRepository.update({ rackPositionId: res.rackPositionId }, { occupancy: OccupancyEnum.NOT_OCCUPIED, saleOrderId: 0, isReserved: false });
            if (racksResponse.affected > 0) {
                flag = true;
            }
            else {
                flag = false;
            }
        }
        console.log(flag);
        if (flag) {
            console.log("flag")
            console.log(new CommonResponse(true, 1001, 'rack position cleared succesfully.'))
            return true;
        }
        else {
            return false;
        }
    }
    async reserveTwoPositions(rackSuggestionRequest: RackSuggestionRequest): Promise<CommonResponse> {
        try
        {
            console.log('//check whether 2 locations availlable or not for the required pallets');
            let availabilityResult = await this.checkLocationAvailability(2, rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId);
            console.log("availabilityResult availabilityResult" + availabilityResult);
            if (availabilityResult === true) {
                console.log('success');
                const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:0,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                console.log(suggestRackPosition.status);
                if (suggestRackPosition.status) {
                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                }
            }
        }
        catch (error) {
            return error
        }
    }

    async reserveRackPosition(rackSuggestionRequest: RackSuggestionRequest): Promise<CommonResponse> {
        console.log("rackSuggestionRequest" + rackSuggestionRequest);
        const connection = getManager();
        console.log(rackSuggestionRequest.stockTypeStatus);
        let reserveTwoPerFlag = false;
        if (rackSuggestionRequest.stockTypeStatus == "dummy") {
            console.log("Dummy Suggestions")
            const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId: rackSuggestionRequest.varientId,packStyleId:rackSuggestionRequest.packStyleId, role:rackSuggestionRequest.role });
            if (suggestRackPosition.status) {
                return new CommonResponse(suggestRackPosition.status, suggestRackPosition.intlCode, suggestRackPosition.internalMessage, suggestRackPosition.data);
            }
            else {
                return new CommonResponse(suggestRackPosition.status, suggestRackPosition.intlCode, suggestRackPosition.internalMessage, suggestRackPosition.data);
            }
        }
        else {
            const checkPositionsReserved = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + rackSuggestionRequest.saleOrderId + ' and occupancy = "' + OccupancyEnum.OCCUPIED + '"';
            const reservedPalletsCount = await connection.query(checkPositionsReserved);
            if (reservedPalletsCount[0].cnt > 0) {
                const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus,varientId:0,packStyleId:rackSuggestionRequest.packStyleId, role:rackSuggestionRequest.role });
                console.log(suggestRackPosition.status);
                if (suggestRackPosition.status) {
                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                }
            }
            else {
                const reservedPalletsCountQuery = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + rackSuggestionRequest.saleOrderId + ' and occupancy != "' + OccupancyEnum.NOT_OCCUPIED + '"';
                const reservedPalletsCountResult = await connection.query(reservedPalletsCountQuery);
                console.log("reservedPalletsCountQuery" + reservedPalletsCountQuery);
                console.log("reservedPalletsCountResult" + reservedPalletsCountResult[0].cnt);
                const palletsAvailable = reservedPalletsCountResult[0].cnt;
                console.log("palletsAvailable" + palletsAvailable);
                let palletsRequiredDetails = await this.saleOrderService.getNoOfRackPositionsForSO({ saleOrderId: rackSuggestionRequest.saleOrderId });
                console.log("palletsRequiredDetails" + palletsRequiredDetails.status);
                console.log("palletsRequiredDetails" + palletsRequiredDetails.data);

                let palletsRequired = 0;
                if (palletsRequiredDetails.status) {
                    palletsRequired = palletsRequiredDetails.data - Number(palletsAvailable);
                    if(palletsRequired === 0){
                        let reserveTwoPositions = await this.reserveTwoPositions(rackSuggestionRequest);
                        if(reserveTwoPositions.status){
                            return new CommonResponse(true, 1011, reserveTwoPositions.internalMessage,reserveTwoPositions.data);
                        }
                        else{
                            return new CommonResponse(false, 1001, "No racks found",);
                        }
                    }
                }
                else {
                    return new CommonResponse(palletsRequiredDetails.status, palletsRequiredDetails.intlCode, palletsRequiredDetails.internalMessage, palletsRequiredDetails.data);
                }
                palletsRequired = Math.abs(palletsRequired);
                console.log("palletsRequired palletsRequired" + palletsRequired);
                const positionsRequired = palletsRequired % 2 === 0 ? Math.ceil(palletsRequired) : Math.ceil(palletsRequired + 1);
                console.log("positionsRequired" + positionsRequired)
                const getCount = await this.rackService.getRackPositionsCount({ plantId: rackSuggestionRequest.plantId, positions: positionsRequired });
                console.log("******************************");
                console.log(getCount);
                console.log(getCount.first_number);

                let minRack = getCount.first_number % 2 === 0 ? Math.ceil(getCount.first_number) + Number(1) : Math.ceil(getCount.first_number);
                let maxRack = Number(minRack) + Number(positionsRequired) - 1;
                let calAvailPer = Math.ceil((Number(getCount.positions) / Number(positionsRequired)) * 100);
                console.log("calAvailPer" + calAvailPer);
                if (getCount.first_number != undefined) {
                    if (calAvailPer >= 25) {
                        if (Number(maxRack) <= Number(getCount.last_number)) {
                            console.log(maxRack + "**" + positionsRequired)
                            let updateRackPosition = 'update ' + appSettings.masters_db + '.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id=' + rackSuggestionRequest.saleOrderId + ',reserved_date=now() where rack_reserve_code between ' + minRack + ' and ' + maxRack;
                            console.log(updateRackPosition);
                            let updateResult = await connection.query(updateRackPosition);
                            console.log("updateResult" + updateResult);
                            let getReservedRacksCount = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id = ' + rackSuggestionRequest.saleOrderId + ' and occupancy IN ("Occupied","Assigned")';
                            let reservedCount = await connection.query(getReservedRacksCount);
                            console.log(reservedCount[0].cnt);
                            console.log(palletsRequired);
                            let reservePer = Math.ceil((reservedCount[0].cnt / positionsRequired) * 100);
                            console.log("reservePer" + reservePer)
                            let updatedReservedPer = 'update ' + appSettings.sales_db + '.so_invoice_details set reserved_per =' + reservePer + ' where sale_order_id = ' + rackSuggestionRequest.saleOrderId;
                            let reserveStatus = await connection.query(updatedReservedPer);
                            console.log(updatedReservedPer);
                            console.log(reserveStatus);
                            console.log(updateRackPosition);
                            console.log(updateResult.affectedRows);
                            let getreservedInfo = 'select COUNT(*) AS cnt,MIN(rack_code) AS fromRack,MAX(rack_code) AS toRack from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + rackSuggestionRequest.saleOrderId + ' and rack_reserve_code between ' + minRack + ' and ' + maxRack;
                            let reservedRacks = await connection.query(getreservedInfo);
                            let reserveMsg = "Reserved " + reservedRacks[0].cnt + " Positions from " + reservedRacks[0].fromRack + " to " + reservedRacks[0].toRack;
                            if (updateResult.affectedRows > 0) {
                                const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus,varientId:0,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                                console.log(suggestRackPosition.status);
                                if (suggestRackPosition.status) {
                                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data, reserveMsg);
                                }
                            }
                        }
                        else {
                            let updateRackPosition = 'update ' + appSettings.masters_db + '.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id=' + rackSuggestionRequest.saleOrderId + ',reserved_date=now() where rack_reserve_code between ' + minRack + ' and ' + getCount.last_number;
                            console.log(updateRackPosition);
                            let updateResult = await connection.query(updateRackPosition);
                            console.log("updateResult" + updateResult);
                            let getReservedRacksCount = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id = ' + rackSuggestionRequest.saleOrderId + ' and occupancy IN ("Occupied","Assigned")';
                            let reservedCount = await connection.query(getReservedRacksCount);
                            console.log(reservedCount[0].cnt);
                            console.log(palletsRequired);
                            let reservePer = Math.ceil((reservedCount[0].cnt / getCount.positions) * 100);
                            console.log("reservePer" + reservePer)
                            let updatedReservedPer = 'update ' + appSettings.sales_db + '.so_invoice_details set reserved_per =' + reservePer + ' where sale_order_id = ' + rackSuggestionRequest.saleOrderId;
                            let reserveStatus = await connection.query(updatedReservedPer);
                            console.log(updatedReservedPer);
                            console.log(reserveStatus);
                            console.log(updateRackPosition);
                            console.log(updateResult.affectedRows);
                            let getreservedInfo = 'select COUNT(*) AS cnt,MIN(rack_code) AS fromRack,MAX(rack_code) AS toRack from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + rackSuggestionRequest.saleOrderId + ' and rack_reserve_code between ' + minRack + ' and ' + maxRack;
                            let reservedRacks = await connection.query(getreservedInfo);
                            let reserveMsg = "Reserved " + reservedRacks[0].cnt + " Positions from " + reservedRacks[0].fromRack + " to " + reservedRacks[0].toRack;
                            if (updateResult.affectedRows > 0) {
                                const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:0,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                                console.log(suggestRackPosition.status);
                                if (suggestRackPosition.status) {
                                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data, reserveMsg);
                                }
                            }
                        }
                    }
                    else if (calAvailPer < 25 && calAvailPer > 0) {
                        if (Number(maxRack) <= Number(getCount.last_number)) {
                            console.log(maxRack + "**" + positionsRequired)
                            let updateRackPosition = 'update ' + appSettings.masters_db + '.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id=' + rackSuggestionRequest.saleOrderId + ',reserved_date=now() where rack_reserve_code between ' + minRack + ' and ' + maxRack;
                            console.log(updateRackPosition);
                            let updateResult = await connection.query(updateRackPosition);
                            console.log("updateResult" + updateResult);
                            let getReservedRacksCount = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id = ' + rackSuggestionRequest.saleOrderId + ' and occupancy IN ("Occupied","Assigned")';
                            let reservedCount = await connection.query(getReservedRacksCount);
                            console.log(reservedCount[0].cnt);
                            console.log(palletsRequired);
                            let reservePer = Math.ceil((reservedCount[0].cnt / positionsRequired) * 100);
                            console.log("reservePer" + reservePer)
                            let updatedReservedPer = 'update ' + appSettings.sales_db + '.so_invoice_details set reserved_per =' + reservePer + ' where sale_order_id = ' + rackSuggestionRequest.saleOrderId;
                            let reserveStatus = await connection.query(updatedReservedPer);
                            console.log(updatedReservedPer);
                            console.log(reserveStatus);
                            console.log(updateRackPosition);
                            console.log(updateResult.affectedRows);
                            let getreservedInfo = 'select COUNT(*) AS cnt,MIN(rack_code) AS fromRack,MAX(rack_code) AS toRack from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + rackSuggestionRequest.saleOrderId + ' and rack_reserve_code between ' + minRack + ' and ' + maxRack;
                            let reservedRacks = await connection.query(getreservedInfo);
                            let reserveMsg = "Reserved " + reservedRacks[0].cnt + " Positions from " + reservedRacks[0].fromRack + " to " + reservedRacks[0].toRack;
                            if (updateResult.affectedRows > 0) {
                                const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus,varientId:0,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                                console.log(suggestRackPosition.status);
                                if (suggestRackPosition.status) {
                                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data, reserveMsg);
                                }
                            }
                        }
                        else {
                            let updateRackPosition = 'update ' + appSettings.masters_db + '.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id=' + rackSuggestionRequest.saleOrderId + ',reserved_date=now() where rack_reserve_code between ' + minRack + ' and ' + getCount.last_number;
                            console.log(updateRackPosition);
                            let updateResult = await connection.query(updateRackPosition);
                            console.log("updateResult" + updateResult);
                            let getReservedRacksCount = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id = ' + rackSuggestionRequest.saleOrderId + ' and occupancy IN ("Occupied","Assigned")';
                            let reservedCount = await connection.query(getReservedRacksCount);
                            console.log(reservedCount[0].cnt);
                            console.log(palletsRequired);
                            let reservePer = Math.ceil((reservedCount[0].cnt / getCount.positions) * 100);
                            console.log("reservePer" + reservePer)
                            let updatedReservedPer = 'update ' + appSettings.sales_db + '.so_invoice_details set reserved_per =' + reservePer + ' where sale_order_id = ' + rackSuggestionRequest.saleOrderId;
                            let reserveStatus = await connection.query(updatedReservedPer);
                            console.log(updatedReservedPer);
                            console.log(reserveStatus);
                            console.log(updateRackPosition);
                            console.log(updateResult.affectedRows);
                            let getreservedInfo = 'select COUNT(*) AS cnt,MIN(rack_code) AS fromRack,MAX(rack_code) AS toRack from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + rackSuggestionRequest.saleOrderId + ' and rack_reserve_code between ' + minRack + ' and ' + maxRack;
                            let reservedRacks = await connection.query(getreservedInfo);
                            let reserveMsg = "Reserved " + reservedRacks[0].cnt + " Positions from " + reservedRacks[0].fromRack + " to " + reservedRacks[0].toRack;
                            if (updateResult.affectedRows > 0) {
                                const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:0,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                                console.log(suggestRackPosition.status);
                                if (suggestRackPosition.status) {
                                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data, reserveMsg);
                                }
                            }
                        }
                    }
                    else {
                        // rereserve logic
                        let availabilityResult = await this.reReserveLocations(Math.ceil(palletsRequired), rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId, 50);
                        if (availabilityResult.status) {
                            console.log('success');
                            const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:0,packStyleId:rackSuggestionRequest.packStyleId, role:rackSuggestionRequest.role });
                            if (suggestRackPosition.status) {
                                return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                            }
                        }
                        else {
                            return new CommonResponse(false, 1010, "No racks available. ");
                        }
                    }
                }
                else {
                    return new CommonResponse(false, 1010, "Something went wrong. ");
                }
            }


            // const getColdStorages = await this.zoneMasterService.getPlantZones({plantId:rackSuggestionRequest.plantId,plantName:""});
            // for(const zone of getColdStorages.data){
            //     const seeion = "SET SESSION group_concat_max_len = 1000000;";
            //     const global_len = await connection.query(seeion)
            //      const getRackreserveCodes = 'SELECT GROUP_CONCAT(rack_reserve_code ORDER BY rack_reserve_code ASC) AS rackReserveCode FROM `rack_position` rp left join rack r on r.rack_id= rp.rack_id WHERE rp.plant_id='+rackSuggestionRequest.plantId+' AND reserved_for_dummy = 0 AND rp.zone_id = '+zone.zoneId+' AND rp.is_reserved = 0 AND rp.occupancy="Not Occupied" AND rp.is_active = true ORDER BY rack_reserve_code ASC '; 
            //      console.log(getRackreserveCodes);
            //     const getCodesList = await connection.query(getRackreserveCodes);
            //     console.log(getCodesList);
            //     // get Count less than requied Positions
            //     const getpositionsBelowCount = "SELECT CONCAT_WS('-', MIN(rack_reserve_code), IF(MAX(rack_reserve_code) = MIN(rack_reserve_code), NULL, MAX(rack_reserve_code))) AS available, MIN(rack_reserve_code) AS minCode, MAX(rack_reserve_code) AS maxCode, COUNT(*) AS COUNT FROM ( SELECT  rack_reserve_code , @group_number := IF(@prev != rack_reserve_code - 1, @group_number + 1, @group_number) AS gn , @prev := rack_reserve_code FROM  rack_position, (SELECT @group_number := 0, @prev := NULL) var_init_subquery ORDER BY rack_reserve_code ) sq  WHERE rack_reserve_code IN ("+getCodesList[0].rackReserveCode+") GROUP BY gn HAVING COUNT <= "+positionsRequired+" ORDER BY COUNT(*) DESC limit 1"
            //     console.log("getpositionsCount"+getpositionsBelowCount);
            //     const getBelowCount = await connection.query(getpositionsBelowCount);
            //     // let belowRangeDiff =0;
            //     // if(getBelowCount != ""){
            //     //     console.log("getBelowCount"+getBelowCount);
            //     //     belowRangeDiff = Number(getBelowCount[0].COUNT) - Number(positionsRequired);
            //     //     console.log("belowRangeDiff"+belowRangeDiff);
            //     // }

            //     // get Count greater than requied Positions
            //     const getpositionsAboveCount = "SELECT CONCAT_WS('-', MIN(rack_reserve_code), IF(MAX(rack_reserve_code) = MIN(rack_reserve_code), NULL, MAX(rack_reserve_code))) AS available, MIN(rack_reserve_code) AS minCode, MAX(rack_reserve_code) AS maxCode, COUNT(*) AS COUNT FROM ( SELECT  rack_reserve_code , @group_number := IF(@prev != rack_reserve_code - 1, @group_number + 1, @group_number) AS gn , @prev := rack_reserve_code FROM  rack_position, (SELECT @group_number := 0, @prev := NULL) var_init_subquery ORDER BY rack_reserve_code ) sq  WHERE rack_reserve_code IN ("+getCodesList[0].rackReserveCode+") GROUP BY gn HAVING COUNT >"+positionsRequired+" ORDER BY COUNT(*) DESC limit 1"
            //     console.log("getpositionsCount"+getpositionsAboveCount);
            //     const getAboveCount = await connection.query(getpositionsAboveCount);
            //     if(getAboveCount != "" && getBelowCount== ""){
            //         console.log("1")
            //         console.log(getAboveCount[0]);
            //         let minRack = getAboveCount[0].minCode;
            //         let maxRack = Number(getAboveCount[0].minCode) + Number(positionsRequired) - 1;
            //         console.log(maxRack+"**"+positionsRequired)
            //         let updateRackPosition='update '+appSettings.masters_db+'.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id='+rackSuggestionRequest.saleOrderId+',reserved_date=now() where rack_reserve_code between '+minRack+' and '+maxRack;
            //         console.log(updateRackPosition);
            //         let updateResult=await connection.query(updateRackPosition);
            //         console.log("updateResult"+updateResult);
            //         if(updateResult.affectedRows>0){
            //             const suggestRackPosition = await this.getSuggestLocation({plantId:rackSuggestionRequest.plantId,saleOrderId:rackSuggestionRequest.saleOrderId,saleOrderItemId:rackSuggestionRequest.saleOrderItemId,mastersCartons:rackSuggestionRequest.mastersCartons,stockTypeStatus:rackSuggestionRequest.stockTypeStatus});
            //             console.log(suggestRackPosition.status);
            //             if(suggestRackPosition.status){
            //                 return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
            //             }
            //         }
            //     }
            //     else if(getAboveCount == "" && getBelowCount!= ""){
            //         console.log("2")
            //         //check count Percentag
            //         const calCountper = Number(Number(getBelowCount[0].COUNT)/Number(positionsRequired))*100;
            //         console.log(calCountper);
            //     }
            //     else if(getAboveCount == "" && getBelowCount == ""){
            //         console.log("3")

            //     }
            //     else if(getAboveCount != "" && getBelowCount != ""){
            //         console.log("4")
            //     }

            // let aboveRangeDiff =0;
            // if(getAboveCount != ""){
            //     console.log("getAboveCount"+getAboveCount[0].minCode);
            //     console.log("getAboveCount"+getAboveCount[0].maxCode);
            //     console.log("getAboveCount"+getAboveCount[0].COUNT);
            //     aboveRangeDiff = Number(getAboveCount[0].COUNT) - Number(positionsRequired);
            //     console.log("aboveRangeDiff"+aboveRangeDiff);
            // }

            // // check the Difference
            // let count
            // console.log("belowRangeDiff"+belowRangeDiff);
            // console.log("aboveRangeDiff"+aboveRangeDiff);

            // if(belowRangeDiff>aboveRangeDiff &&  aboveRangeDiff != 0){
            //     count = getAboveCount;
            // }
            // else if(belowRangeDiff<=aboveRangeDiff && belowRangeDiff != 0){
            //     count = getBelowCount;
            // }
            // console.log("count"+count)
            // const calCountper = Number(Number(count[0].COUNT)/Number(positionsRequired))*100;
            // console.log("calCountper"+calCountper);
            // if(calCountper >= 25){
            //     console.log(count);

            // }
            // else if(calCountper < 25){
            //     console.log("Rereserve logic")
            // }

            // for (const res of getAboveCount) {
            //     console.log(res);
            //     // if(res.COUNT)

            // }
            // }

        }
    }

    async reserveRackPositions(rackSuggestionRequest: RackSuggestionRequest): Promise<CommonResponse> {
        const connection = getManager();
        console.log(rackSuggestionRequest.stockTypeStatus);
        if (rackSuggestionRequest.stockTypeStatus == "dummy") {
            console.log("Dummy Suggestions")
            const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId: rackSuggestionRequest.varientId,packStyleId: rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role});
            if (suggestRackPosition.status) {
                return new CommonResponse(suggestRackPosition.status, suggestRackPosition.intlCode, suggestRackPosition.internalMessage, suggestRackPosition.data);
            }
            else {
                return new CommonResponse(suggestRackPosition.status, suggestRackPosition.intlCode, suggestRackPosition.internalMessage, suggestRackPosition.data);
            }
        } else {
            //check whether privously cartons are received or not
            const stockExistancyQuery = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + rackSuggestionRequest.saleOrderId + ' and occupancy = "' + OccupancyEnum.OCCUPIED + '" limit 1';
            console.log(stockExistancyQuery);
            const stockExistancyResult = await connection.query(stockExistancyQuery);
            console.log("stockExistancyResult" + stockExistancyResult[0].cnt)
            if (stockExistancyResult[0].cnt > 0) {
                // for (const stockCheck of stockExistancyResult) {
                console.log('//stock found for the sale order');
                const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:rackSuggestionRequest.varientId,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                console.log(suggestRackPosition);
                if (suggestRackPosition.status || suggestRackPosition.status != undefined) {
                    return new CommonResponse(true, suggestRackPosition.intlCode, suggestRackPosition.internalMessage, suggestRackPosition.data);
                }
                else {
                    return new CommonResponse(false, suggestRackPosition.intlCode, suggestRackPosition.internalMessage, suggestRackPosition.data);
                }
                // }    
            }
            else {
                //calculate pallets required for the SO 
                // Need to check Reserved locations count and subtract from palletsRequired.
                const reservedPalletsCountQuery = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + rackSuggestionRequest.saleOrderId + ' and occupancy != "' + OccupancyEnum.NOT_OCCUPIED + '"';
                const reservedPalletsCountResult = await connection.query(reservedPalletsCountQuery);
                console.log("reservedPalletsCountQuery" + reservedPalletsCountQuery);
                console.log("reservedPalletsCountResult" + reservedPalletsCountResult);
                const palletsAvailable = reservedPalletsCountResult[0].cnt;
                console.log("palletsAvailable" + palletsAvailable);
                let palletsRequiredDetails = await this.saleOrderService.getNoOfRackPositionsForSO({ saleOrderId: rackSuggestionRequest.saleOrderId });
                console.log("palletsRequiredDetails" + palletsRequiredDetails.data);
                let palletsRequired = 0;
                if (palletsRequiredDetails.status) {
                    palletsRequired = palletsRequiredDetails.data - Number(palletsAvailable);
                }
                else {
                    return new CommonResponse(palletsRequiredDetails.status, palletsRequiredDetails.intlCode, palletsRequiredDetails.internalMessage, palletsRequiredDetails.data);
                }
                palletsRequired = Math.abs(palletsRequired);
                console.log("palletsRequired palletsRequired" + palletsRequired);
                if (palletsRequired === 0) {
                    palletsRequired = 2;
                }
                //check whether 100% locations availlable or not for the required pallets
                // let availabilityResult  = await this.reReserveLocations(Math.ceil(palletsRequired/8),3,false,rackSuggestionRequest.saleOrderId,25);
                let availabilityResult = await this.checkLocationAvailability(Math.ceil(palletsRequired), rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId);
                console.log("availabilityResult availabilityResult" + availabilityResult);
                if (availabilityResult === true) {
                    console.log('success');
                    const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus,varientId:rackSuggestionRequest.varientId,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                    console.log(suggestRackPosition.status);
                    if (suggestRackPosition.status) {
                        return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                    }
                }

                else {
                    console.log('failed');
                    console.log('//check whether 50% locations availlable or not for the required pallets');

                    // const getAvailabilityInAllRacks = 'select count(*) AS cnt, rp.rack_id AS rackId,rp.rack_position_code AS rackPositionCode from '+appSettings.masters_db+'.rack_position rp left join '+appSettings.masters_db+'.rack r on r.rack_id =  rp.rack_id where occupancy = "Not Occupied" and rp.plant_id='+rackSuggestionRequest.plantId+' and r.reserved_for_dummy=0 and rp.is_active = true group by rp.rack_id,rp.rack_position_code';
                    // console.log(getAvailabilityInAllRacks);
                    // const AvailablePositionsCnt = await connection.query(getAvailabilityInAllRacks);
                    // console.log(AvailablePositionsCnt);

                    let availabilityResult = await this.checkLocationAvailability(Math.ceil(palletsRequired / 2), rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId);
                    console.log("availabilityResult availabilityResult" + availabilityResult);
                    if (availabilityResult === true) {
                        console.log('success');
                        const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus,varientId:rackSuggestionRequest.varientId,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                        console.log(suggestRackPosition.status);
                        if (suggestRackPosition.status) {
                            return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                        }
                    }
                    else {
                        let availabilityResult = await this.reReserveLocations(Math.ceil(palletsRequired / 2), rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId, 50);
                        if (availabilityResult.status) {
                            console.log('success');
                            const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus,varientId:rackSuggestionRequest.varientId,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                            if (suggestRackPosition.status) {
                                return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                            }
                        }
                        else {
                            console.log('//check whether 25% locations availlable or not for the required pallets');
                            let availabilityResult = await this.checkLocationAvailability(Math.ceil(palletsRequired / 4), rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId);
                            console.log("availabilityResult availabilityResult" + availabilityResult);
                            if (availabilityResult === true) {
                                console.log('success');
                                const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:rackSuggestionRequest.varientId,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                                console.log(suggestRackPosition.status);
                                if (suggestRackPosition.status) {
                                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                                }
                            }
                            else {
                                let availabilityResult = await this.reReserveLocations(Math.ceil(palletsRequired / 4), rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId, 25);
                                if (availabilityResult.status) {
                                    console.log('success');
                                    const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:rackSuggestionRequest.varientId, packStyleId:rackSuggestionRequest.packStyleId, role:rackSuggestionRequest.role });
                                    if (suggestRackPosition.status) {
                                        return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                                    }
                                    //get the location
                                }
                                else {
                                    console.log('//check whether 2 locations availlable or not for the required pallets');
                                    let availabilityResult = await this.checkLocationAvailability(2, rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId);
                                    console.log("availabilityResult availabilityResult" + availabilityResult);
                                    if (availabilityResult === true) {
                                        console.log('success');
                                        const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:rackSuggestionRequest.varientId,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                                        console.log(suggestRackPosition.status);
                                        if (suggestRackPosition.status) {
                                            return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                                        }
                                    }
                                    else {
                                        let availabilityResult = await this.reReserveLocations(2, rackSuggestionRequest.plantId, false, rackSuggestionRequest.saleOrderId, 2);
                                        if (availabilityResult.status) {
                                            console.log('success');
                                            const suggestRackPosition = await this.getSuggestLocation({ plantId: rackSuggestionRequest.plantId, saleOrderId: rackSuggestionRequest.saleOrderId, saleOrderItemId: rackSuggestionRequest.saleOrderItemId, mastersCartons: rackSuggestionRequest.mastersCartons, stockTypeStatus: rackSuggestionRequest.stockTypeStatus, varientId:rackSuggestionRequest.varientId,packStyleId:rackSuggestionRequest.packStyleId,role:rackSuggestionRequest.role });
                                            if (suggestRackPosition.status) {
                                                return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                                            }
                                        }
                                        else {
                                            return new CommonResponse(false, 1010, "sorry no locations available");

                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        return new CommonResponse(false, 1010, "Sorry unknown Stock Type. ");
    }
    async reReserveLocations(locationsRequired: number, plantId: number, dummyStatus: boolean, saleOrderId: number, reservePercentage: number): Promise<CommonResponse> {
        const connection = getManager();
        //get % of locations
        let saleOrdersQuery = `SELECT si.sale_order_id,SUM(si.job_cases) AS required,SUM(si.reported_cases) AS reported_cases,ROUND((SUM(si.reported_cases)/SUM(si.job_cases))*100,0) AS occupied,s.stock_reported_date,s.reserved_per,rp.rack_id FROM ` + appSettings.sales_db + `.sale_order_items si LEFT JOIN ` + appSettings.masters_db + `.rack_position rp ON rp.sale_order_id=si.sale_order_id AND rp.rack_position_id = (SELECT MAX(rack_position_id) FROM ` + appSettings.masters_db + `.rack_position rp 
        WHERE rp.sale_order_id = si.sale_order_id) LEFT JOIN `+ appSettings.sales_db + `.sale_order so ON so.sale_order_id=si.sale_order_id LEFT JOIN ` + appSettings.sales_db + `.so_invoice_details s ON s.sale_order_id=si.sale_order_id WHERE rp.plant_id = ` + plantId + ` and reported_cases>0 and so.status IN ("Open","Inprogress") GROUP BY sale_order_id HAVING occupied <` + reservePercentage + ` ORDER BY s.reserved_per DESC , s.stock_reported_date ASC `;

        // let saleOrdersQuery=`SELECT si.sale_order_id,SUM(si.job_cases) AS required,SUM(si.reported_cases) AS reported_cases,ROUND((SUM(si.reported_cases)/SUM(si.job_cases))*100,0) AS occupied,s.stock_reported_date FROM `+appSettings.sales_db+`.sale_order_items si LEFT JOIN `+appSettings.sales_db+`.so_invoice_details s ON s.sale_order_id=si.sale_order_id LEFT JOIN `+appSettings.masters_db+`.rack_position rp ON rp.sale_order_id=si.sale_order_id where si.reported_cases > 0 and rp.is_reserved = 1 GROUP BY sale_order_id HAVING occupied<`+reservePercentage+` ORDER BY s.stock_reported_date `;
        // console.log('saleOrdersQuery');
        console.log(saleOrdersQuery);
        const saleOrderResult = await connection.query(saleOrdersQuery);
        console.log("saleOrderResult Length" + saleOrderResult)
        console.log("saleOrderResult Length" + saleOrderResult.length)
        if (saleOrderResult.length > 0) {
            // let result = saleOrderResult.map(a => a.sale_order_id);
            for (const saleOrders of saleOrderResult) {
                console.log(saleOrders.stock_reported_date)

                if (saleOrders.stock_reported_date != null) {
                    const saleOrderIdReserved = saleOrders.sale_order_id;
                    //get the 
                    let locationsAvailableQuery = `select count(*) as cnt,max(rack_reserve_code) as rack_position_code, rack_id as rackId from ` + appSettings.masters_db + `.rack_position where sale_order_id=` + saleOrderIdReserved + ` and is_reserved=1 and is_active = true and occupancy='Occupied'`;
                    let locationsAvailableResult = await connection.query(locationsAvailableQuery);
                    console.log('locationsAvailableQuery');
                    console.log(locationsAvailableQuery)
                    console.log(locationsAvailableResult.length)
                    let palletsRequired = locationsAvailableResult[0].cnt;
                    console.log(palletsRequired);
                    const positionsRequired = palletsRequired % 2 === 0 ? Math.ceil(palletsRequired) : Math.ceil(palletsRequired - 1);
                    console.log("positionsRequired" + positionsRequired);
                    if (positionsRequired > 0) {
                        const halfPositions = Math.ceil(positionsRequired / 2);
                        const palletsRequired = halfPositions % 2 === 0 ? Math.ceil(halfPositions) : Math.ceil(halfPositions - 1);
                        console.log(palletsRequired);
                        let positionsResult = await this.rackService.getRereserveRackPositions({ plantId: plantId, positions: palletsRequired, saleOrderId: saleOrderIdReserved });
                        console.log(positionsResult);
                        if (positionsResult.first_number != undefined) {
                            let maxRack = positionsResult.last_number % 2 === 0 ? Math.ceil(positionsResult.last_number) : Math.ceil(positionsResult.last_number) - Number(1);
                            let minRack = Number(maxRack) - Number(palletsRequired) + Number(1);
                            console.log("minRack" + minRack);
                            console.log("maxRack" + maxRack);
                            if (Number(minRack) >= Number(positionsResult.first_number)) {
                                console.log(maxRack + "**" + positionsRequired)
                                let updateRackPosition = 'update ' + appSettings.masters_db + '.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id=' + saleOrderId + ',reserved_date=now() where rack_reserve_code between ' + minRack + ' and ' + maxRack;
                                console.log(updateRackPosition);
                                let updateResult = await connection.query(updateRackPosition);
                                console.log("updateResult" + updateResult);
                                let getReservedRacksCount = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id = ' + saleOrderIdReserved + ' and occupancy IN ("Occupied","Assigned")';
                                let reservedCount = await connection.query(getReservedRacksCount);
                                console.log(reservedCount[0].cnt);
                                console.log(palletsRequired);
                                let palletsRequiredDetails = await this.saleOrderService.getNoOfRackPositionsForSO({ saleOrderId: saleOrderIdReserved });
                                let palletsRequiredforSo = palletsRequiredDetails.data ? palletsRequiredDetails.data : 0;
                                let reservePer = Math.ceil((reservedCount[0].cnt / palletsRequiredforSo) * 100);
                                console.log("reservePer" + reservePer)
                                let updatedReservedPer = 'update ' + appSettings.sales_db + '.so_invoice_details set reserved_per =' + reservePer + ' where sale_order_id = ' + saleOrderIdReserved;
                                let reserveStatus = await connection.query(updatedReservedPer);

                                let getNewReservedRacksCount = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id = ' + saleOrderId + ' and occupancy IN ("Occupied","Assigned")';
                                let newReservedCount = await connection.query(getNewReservedRacksCount);
                                console.log(newReservedCount[0].cnt);
                                console.log(palletsRequired);
                                let newPalletsRequiredDetails = await this.saleOrderService.getNoOfRackPositionsForSO({ saleOrderId: saleOrderId });
                                let newPalletsRequiredforSo = newPalletsRequiredDetails.data ? newPalletsRequiredDetails.data : 0;
                                let newReservePer = Math.ceil((newReservedCount[0].cnt / newPalletsRequiredforSo) * 100);
                                console.log("newReservePer" + newReservePer)
                                let newUpdatedReservedPer = 'update ' + appSettings.sales_db + '.so_invoice_details set reserved_per =' + newReservePer + ' where sale_order_id = ' + saleOrderId;
                                let newreserveStatus = await connection.query(newUpdatedReservedPer);


                                let getreservedInfo = 'select COUNT(*) AS cnt,MIN(rack_code) AS fromRack,MAX(rack_code) AS toRack from ' + appSettings.masters_db + '.rack_position where sale_order_id=' + saleOrderId + ' and rack_reserve_code between ' + minRack + ' and ' + maxRack;
                                let reservedRacks = await connection.query(getreservedInfo);
                                let reserveMsg = "Reserved " + reservedRacks[0].cnt + " Positions from " + reservedRacks[0].fromRack + " to " + reservedRacks[0].toRack;



                                console.log(updatedReservedPer);
                                console.log(reserveStatus);
                                console.log(updateRackPosition);
                                console.log(updateResult.affectedRows);

                                if (updateResult.affectedRows > 0) {
                                    return new CommonResponse(true, 1001, "Reserved rack positions successfully", reserveMsg);
                                    // return true;
                                }
                                else {
                                    return new CommonResponse(false, 1001, "Something went wrong", reserveMsg);
                                    // return false;
                                }
                            }
                            else {
                                return new CommonResponse(false, 1001, "Something went wrong");
                                // return false;
                            }
                        }
                    }
                    // if(locationsAvailableResult.length>0){
                    //     for(const locationsAvailable of locationsAvailableResult){
                    //         console.log(locationsAvailable);
                    //         if(locationsAvailable.cnt>0){
                    //             console.log(locationsAvailable.cnt+'>='+locationsRequired);
                    //             const positionsRequired= locationsAvailable.cnt % 2 === 0?Math.ceil(locationsAvailable.cnt):Math.ceil(locationsAvailable.cnt-1);
                    //             console.log(positionsRequired);
                    //             let maxReservedCode=locationsAvailable.rack_position_code;
                    //             let minReservedCode=locationsAvailable.rack_position_code-positionsRequired;
                    //             let updateRackPosition='update '+appSettings.masters_db+'.rack_position set is_reserved=1, occupancy= "Occupied", sale_order_id='+saleOrderId+',reserved_date=now() where plant_id='+plantId+' and sale_order_id ='+saleOrderIdReserved+' and rack_id ='+locationsAvailable.rackId+'  and rack_reserve_code between '+minReservedCode+' and '+maxReservedCode;
                    //             console.log(updateRackPosition);
                    //             const updateResult=await connection.query(updateRackPosition);

                    //             let palletsRequiredDetails = await this.saleOrderService.getNoOfRackPositionsForSO({saleOrderId:saleOrderIdReserved});
                    //             console.log("palletsRequiredDetails.data"+palletsRequiredDetails.data);
                    //             let palletsRequired = palletsRequiredDetails.data?palletsRequiredDetails.data:0;
                    //             console.log('reReserveLocations'+locationsRequired)
                    //             let getReservedRacksCount = 'select count(*) as cnt from '+appSettings.masters_db+'.rack_position where sale_order_id = '+saleOrderIdReserved+' and is_active = true and occupancy IN ("Occupied","Assigned")';
                    //             let reservedCount = await connection.query(getReservedRacksCount);
                    //             console.log(reservedCount[0].cnt);
                    //             let reservePer = Math.ceil((reservedCount[0].cnt/palletsRequired)*100);
                    //             console.log("reservePer" + reservePer)
                    //             let updatedReservedPer = 'update '+appSettings.sales_db+'.so_invoice_details set reserved_per ='+reservePer+' where sale_order_id = '+saleOrderIdReserved;
                    //             let reserveStatus = await connection.query(updatedReservedPer);
                    //             console.log(updatedReservedPer);
                    //             console.log(reserveStatus);
                    //             return true;
                    //         }
                    //     }
                    // }
                }
            }
            //reserve location for the above sale order


        } else {
            // console.log('Reported Stock not found. ')
            return new CommonResponse(false, 1001, "Reported Stock not found.");
            // return false;
        }
        // return true;
    }
    async checkLocationAvailability(locationsRequired: number, plantId: number, dummyStatus: boolean, saleOrderId: number): Promise<boolean> {
        let palletsRequiredDetails = await this.saleOrderService.getNoOfRackPositionsForSO({ saleOrderId: saleOrderId });
        console.log("palletsRequiredDetails.data" + palletsRequiredDetails.data);
        let palletsRequired = palletsRequiredDetails.data ? palletsRequiredDetails.data : 0;
        // console.log('welcome')
        console.log(locationsRequired % 2);
        const positionsRequired = locationsRequired % 2 === 0 ? Math.ceil(locationsRequired) : Math.ceil(locationsRequired + 1);

        const connection = getManager();
        console.log("dummyStatus" + dummyStatus);
        console.log("positionsRequired" + positionsRequired);
        if (dummyStatus == true) {
            const getRacks = 'select rack_id from ' + appSettings.masters_db + '.rack where reserved_for_dummy=1 and plant_id=' + plantId + ' order by rack_code';
            console.log(getRacks);
            const racksList = await connection.query(getRacks);
            if (racksList.length > 0) {
                console.log(racksList)
                for (const rack of racksList) {
                    console.log(rack.rack_id);
                }
            } else {
                console.log('Sorry no racks found');
            }
        } else {
            //Reserver for Sale Order

            const getRacks = 'select rack_id from ' + appSettings.masters_db + '.rack where reserved_for_dummy=0 and plant_id=' + plantId;
            const racksList = await connection.query(getRacks);
            console.log(racksList)
            if (racksList.length > 0) {
                console.log(racksList)
                let status_check = true;
                // await racksList.forEach(async res => {
                for (const res of racksList) {
                    console.log(res);
                    let rack_position_code = 0;
                    if (status_check == true) {
                        console.log('status_check');
                        console.log(status_check);
                        const rackPositionsMinMaxQuery = 'SELECT MIN(rack_position_code) as startPosition,Min(rack_position_code)-1+' + positionsRequired + ' as endPosition FROM ' + appSettings.masters_db + '.rack_position WHERE plant_id=' + plantId + ' and rack_id=' + res.rack_id + ' and is_reserved=0 and is_active = true and rack_position_code>' + rack_position_code;
                        const rackMinMaxResult = await connection.query(rackPositionsMinMaxQuery);
                        console.log(rackMinMaxResult + 'rackPositionsMinMaxQuery');
                        if (rackMinMaxResult.length > 0 && rackMinMaxResult[0].startPosition != null && rackMinMaxResult[0].endPosition) {
                            for (const rackMinMax of rackMinMaxResult) {
                                console.log(rackMinMax.startPosition + '-----' + rackMinMax.endPosition + '--------' + positionsRequired);
                                const checkAvailability = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where plant_id=' + plantId + ' and rack_id =' + res.rack_id + ' and rack_position_type="front" and is_reserved=0 and is_active = true and rack_position_code between ' + rackMinMax.startPosition + ' and ' + rackMinMax.endPosition;
                                const availabilityResult = await connection.query(checkAvailability);
                                console.log('checkAvailability')
                                console.log(checkAvailability);
                                console.log(availabilityResult[0].cnt);
                                if (availabilityResult[0].cnt > 0) {
                                    for (const availabilityRes of availabilityResult) {
                                        console.log("test" + availabilityRes.cnt);
                                        if (availabilityRes.cnt >= (positionsRequired / 2)) {
                                            console.log('success');
                                            status_check = false;
                                            let updateRackPosition = 'update ' + appSettings.masters_db + '.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id=' + saleOrderId + ',reserved_date=now() where plant_id=' + plantId + ' and rack_id=' + res.rack_id + ' and rack_position_code between ' + rackMinMax.startPosition + ' and ' + rackMinMax.endPosition;
                                            let updateResult = await connection.query(updateRackPosition);
                                            let getReservedRacksCount = 'select count(*) as cnt from ' + appSettings.masters_db + '.rack_position where sale_order_id = ' + saleOrderId + ' and occupancy IN ("Occupied","Assigned")';
                                            let reservedCount = await connection.query(getReservedRacksCount);
                                            console.log(reservedCount[0].cnt);
                                            console.log(palletsRequired);
                                            let reservePer = Math.ceil((reservedCount[0].cnt / positionsRequired) * 100);
                                            console.log("reservePer" + reservePer)
                                            let updatedReservedPer = 'update ' + appSettings.sales_db + '.so_invoice_details set reserved_per =' + reservePer + ' where sale_order_id = ' + saleOrderId;
                                            let reserveStatus = await connection.query(updatedReservedPer);
                                            console.log(updatedReservedPer);
                                            console.log(reserveStatus);
                                            console.log(updateRackPosition);
                                            console.log(updateResult.affectedRows);

                                            status_check = updateResult.affectedRows > 0 ? true : false;
                                            return status_check;
                                            // break;
                                        }
                                        else {
                                            const getMaxReserverd = 'select COALESCE(MAX(rack_position_id),0) as lastRackPosition from ' + appSettings.masters_db + '.rack_position where plant_id=' + plantId + ' and rack_id =' + res.rack_id + ' and rack_position_type="front" and is_reserved=1 and rack_position_code between ' + rackMinMax.startPosition + ' and ' + rackMinMax.endPosition;
                                            console.log('getMaxReserverd');
                                            console.log(getMaxReserverd);
                                            const maxReservedRes = await connection.query(getMaxReserverd);
                                            console.log("getMaxReserverd length" + maxReservedRes.length)
                                            if (maxReservedRes.length > 0) {
                                                for (const getMaxId of maxReservedRes) {
                                                    console.log(getMaxId);
                                                    rack_position_code = getMaxId.lastRackPosition;
                                                    console.log('rack_position_code');
                                                    console.log(rack_position_code);
                                                    if (rack_position_code == 0) {
                                                        status_check = true;
                                                    } else {
                                                        console.log('Locations not available in Rack')
                                                        status_check = false;
                                                        return status_check
                                                    }

                                                }
                                            } else {
                                                console.log('error getMaxReserverd ' + getMaxReserverd);
                                                return false;
                                            }
                                            console.log('error checkAvailability ' + checkAvailability)
                                        }
                                    }
                                } else {
                                    // console.log('error checkAvailability '+checkAvailability);
                                    // return true;
                                }

                            }
                        } else {
                            // status_check=false;
                            // console.log('error in rackPositionsMinMaxQuery'+ rackPositionsMinMaxQuery)
                            // return false;
                        }


                        // status_check=false;
                    }
                }
            } else {
                // console.log('Sorry no racks found');
                return false;
            }
        }
    }
    async getReserveRackPosition(rackPositionIdRequest: RackPositionIdRequest): Promise<CommonResponse> {
        try {
            let saleOrderId;
            let varientId
            // let minGrade;
            // let maxGrade;
            if (rackPositionIdRequest.isReserved) {
                saleOrderId = rackPositionIdRequest.saleOrderId;
                varientId = rackPositionIdRequest.varientId;
                // minGrade = rackPositionIdRequest.minGrade;
                // maxGrade = rackPositionIdRequest.maxGrade;
            }
            else {
                saleOrderId = null;
                varientId = null;
                // minGrade = null;
                // maxGrade = null;
            }
            const getRackDetails = await this.rackRepository.findOne({
                where: { rackPositionId: rackPositionIdRequest.rackPositionId, zoneId: rackPositionIdRequest.zoneId, plantId: rackPositionIdRequest.plantId, rackId: rackPositionIdRequest.rackId }
            });
            console.log(getRackDetails);
            if (getRackDetails != undefined) {
                let status = rackPositionIdRequest.isReserved ? OccupancyEnum.OCCUPIED : OccupancyEnum.NOT_OCCUPIED
                const rackStatus = await this.rackRepository.update({ zoneId: rackPositionIdRequest.zoneId, plantId: rackPositionIdRequest.plantId, rackId: rackPositionIdRequest.rackId, rackPositionCode: getRackDetails.rackPositionCode }, { isReserved: rackPositionIdRequest.isReserved, updatedUser: rackPositionIdRequest.updatedUser, saleOrderId: saleOrderId, varientId: varientId, reservedDate: new Date(), occupancy: status });
                if (rackStatus.affected > 0) {
                    console.log(rackPositionIdRequest.isReserved);
                    return new CommonResponse(true, 1001, rackPositionIdRequest.isReserved ? "Rack Reserved Successfully. " : "Rack Unreserved successfully. ", getRackDetails);
                }
                else {
                    return new CommonResponse(false, 1010, "Something went wrong. ", getRackDetails);
                }
            }
            return new CommonResponse(false, 1010, "Rack Position not found. ", getRackDetails);
        }
        catch (error) {
            return error
        }
    }

    async getLocationByZRL(req: RackZoneLevelRequest) {
        try {
            const response = await this.rackRepository.find({
                select: ['rackPositionId'], where: { rackId: req.rackId, rackLevel: req.levelId, zoneId: req.zoneId },
            });
            console.log('locationResponse', response)
            if (response) {
                return response;
            } else {
                return 'Location not found';
            }
        }
        catch (error) {
            return error
        }
    }


    async getSuggestLocation(locationsRequest: LocationsRequest): Promise<CommonResponse> {
        try {
            const connection = getManager();
            // let availableRackPositions = "Select rp.plant_id AS plantId, 0 AS totalCases, 0 AS inStockCases,zm.zone_id AS zoneId,zm.zone_name AS zoneName,rack_position_code AS rackPositionCode, rack_position_id AS rackPositionId, rack_code AS rackCode, occupancy AS occupancy from "+appSettings.masters_db+".rack_position rp LEFT JOIN zone_master zm on zm.zone_id = rp.zone_id where rp.is_active = true and occupancy IN ('Occupied','Occupied-NR','Not Occupied') and rp.plant_id= "+locationsRequest.plantId+" order by rp.zone_id, rp.rack_id,rp.rack_level,rp.rack_column asc";
            // let availableLocationData: RackSuggestionResponseDto[] = await connection.query(availableRackPositions);

            let availRackPositions = await this.getAvailableRackPositionsForPlantId({plantId:locationsRequest.plantId,saleOrderId:locationsRequest.saleOrderId,saleOrderItemId:locationsRequest.saleOrderItemId,mastersCartons:locationsRequest.mastersCartons,stockTypeStatus:locationsRequest.stockTypeStatus,varientId:locationsRequest.varientId,packStyleId:locationsRequest.packStyleId,role:locationsRequest.role});
            console.log("availRackPositions"); 
            console.log(availRackPositions); 
            let availableLocationData:RackPositionModel[] = availRackPositions.status?availRackPositions.data:[]


            if (locationsRequest.stockTypeStatus == "dummy") {
                console.log(locationsRequest);
                let location;
                let response: RackSuggestionResponseDto[] = [];
                let rackPositions = 'select rack_position_code AS rackPositionCode, rack_position_id AS rackPositionId, rack_code AS rackCode, occupancy AS occupancy,zm.zone_id AS zoneId,zm.zone_name AS zoneName from ' + appSettings.masters_db + '.rack_position LEFT JOIN zone_master zm on zm.zone_id = rack_position.zone_id where rack_position.plant_id=' + locationsRequest.plantId + ' and occupancy = "Not Occupied" ';
                console.log(locationsRequest.role)
                if(locationsRequest.role === "WAREHOUSE INCHARGE"){
                    rackPositions = rackPositions + " ";
                }
                else{
                    console.log("jhjhjkhjhkhkhk");
                    rackPositions = rackPositions + ' and varient_id =' + locationsRequest.varientId;
                }
                rackPositions = rackPositions + ' order by rack_position_code asc';

                location = await connection.query(rackPositions);
                if (location.length > 0) {
                    for (const loc of location) {
                        const rackSuggestionDto = new RackSuggestionResponseDto(locationsRequest.plantId, 0, 0, loc.zoneId, loc.zoneName, loc.rackPositionCode, loc.rackPositionId, loc.rackCode, loc.occupancy);
                        response.push(rackSuggestionDto);
                    }
                    return new CommonResponse(true, 10001, "Suggesting Location For SO. ", response);
                }
                else {
                    return new CommonResponse(false, 10001, "No racks reserved for varient, please reserve. ", response);
                }
            }
            else {
                let location;
                // const getreservedLocationForSo='select rack_position_id from '+appSettings.masters_db+'.rack_position where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id='+locationsRequest.plantId + ' and occupancy = "' + OccupancyEnum.NOT_OCCUPIED + '"';
                // console.log('getreservedLocationForSo'+getreservedLocationForSo);
                // const locationsList=await connection.query(getreservedLocationForSo);
                // console.log('locationsList'+locationsList);
                // if(locationsList.length>0){
                const existingStock = 'select pallet_capacity AS palletCapacity from ' + appSettings.warehouse_db + '.stock where sale_order_id =' + locationsRequest.saleOrderId + ' and sale_order_item_id = ' + locationsRequest.saleOrderItemId + ' and status = "' + FgStockStatusEnum.StockIn + '" ORDER BY stock_id desc limit 1';
                const stockDetails = await connection.query(existingStock);
                let palletCapacity = 0;
                if (stockDetails.length > 0) {
                    console.log("hi" + stockDetails[0].palletCapacity);
                    palletCapacity = stockDetails[0].palletCapacity;
                }
                else {
                    const saleOrderItemDetailsQuery = 'select pouches AS pouches, pouch_weight AS pouchWeight,uom_id AS uomId from ' + appSettings.sales_db + '.sale_order_items where sale_order_id = ' + locationsRequest.saleOrderId + ' and sale_order_item_id = ' + locationsRequest.saleOrderItemId + ' limit 1';
                    const saleOrderItemDetails = await connection.query(saleOrderItemDetailsQuery);
                    console.log("saleOrderItemDetails" + saleOrderItemDetails);
                    // const saleOrderItemDetails = await this.saleOrderService.getPackingStyleDetails({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                    const checkPalletCapacity = await this.packingMethodService.getPalletCapacity({ noOfPouches: saleOrderItemDetails[0].pouches, pouchesPerRow: saleOrderItemDetails[0].pouchWeight, uomId: saleOrderItemDetails[0].uomId });
                    console.log("checkPalletCapacity.status" + checkPalletCapacity.status);
                    if (checkPalletCapacity.status) {
                        palletCapacity = checkPalletCapacity.data.palletCapacity;
                    }
                    else {
                        return new CommonResponse(false, 1001, "Packing Method not found. ");
                    }
                }
                console.log("palletCapacity" + palletCapacity);
                console.log("locationsRequest.mastersCartons" + locationsRequest.mastersCartons);
                console.log("Pallets Required" + Number(Number(locationsRequest.mastersCartons) / Number(palletCapacity)) * 100);
                if (Number(locationsRequest.mastersCartons / palletCapacity) * 100 >= 100) {
                    const rackPositions = 'select rack_reserve_code AS rackPositionCode, rack_position_id AS rackPositionId, rack_code AS rackCode, occupancy AS occupancy,zm.zone_id AS zoneId,zm.zone_name AS zoneName from ' + appSettings.masters_db + '.rack_position LEFT JOIN ' + appSettings.masters_db + '.zone_master zm on zm.zone_id = rack_position.zone_id where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level != 1 and occupancy != "Assigned" and rack_reserve_code = (select MIN(rack_reserve_code) from ' + appSettings.masters_db + '.rack_position where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level != 1 and occupancy != "Assigned")';
                    console.log('getLocationForSo' + rackPositions);
                    location = await connection.query(rackPositions);
                    console.log("location" + location.length);
                    if (location.length > 0 && location[0].rackPositionCode != null) {
                        const totalCases = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                        const stock = await this.fGStockService.getStockQtyForSoAndSoItem({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                        console.log("hhhhhhhhhhh" + stock.data)
                        console.log("role" + locationsRequest.role)

                        let response: RackSuggestionResponseDto[] = [];
                        const rackSuggestionDto = new RackSuggestionResponseDto(locationsRequest.plantId, totalCases.status ? totalCases.data.cases : 0, totalCases.status ? totalCases.data.reportedCases : 0, location[0].zoneId, location[0].zoneName, location[0].rackPositionCode, location[0].rackPositionId, location[0].rackCode, location[0].occupancy);
                        response.push(rackSuggestionDto)
                        let newResponse;
                        if(locationsRequest.role === "WAREHOUSE INCHARGE"){
                            let availData = availableLocationData.filter((res) => res.rackPositionId != response[0].rackPositionId);
                            newResponse = [...response, ...availData];
                        }
                        else{
                            newResponse = response;
                        }
                       
                        // for(const rack of location){
                        //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                        return new CommonResponse(true, 10001, "Suggesting Location For SO", newResponse);
                        //     }
                        //     else{
                        //         return new CommonResponse(false, 1010, "No racks reserved for SO");
                        //     }
                        // }
                    }

                    else {
                        const rackPositions = 'select rack_reserve_code AS rackPositionCode, rack_position_id AS rackPositionId, rack_code AS rackCode, occupancy AS occupancy,zm.zone_id AS zoneId,zm.zone_name AS zoneName from ' + appSettings.masters_db + '.rack_position LEFT JOIN zone_master zm on zm.zone_id = rack_position.zone_id where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level = 1  and occupancy != "Assigned" and rack_reserve_code = (select MIN(rack_reserve_code) from ' + appSettings.masters_db + '.rack_position where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level = 1  and occupancy != "Assigned")';
                        console.log('getLocationForSo' + rackPositions);
                        location = await connection.query(rackPositions);
                        if (location.length > 0 && location[0].rackPositionCode != null) {
                            // for(const rack of location){
                            //     console.log("rack rack"+rack);
                            //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                            const totalCases = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                            const stock = await this.fGStockService.getStockQtyForSoAndSoItem({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                            console.log("ggggggggggg" + stock.data)
                            let response: RackSuggestionResponseDto[] = [];

                            const rackSuggestionDto = new RackSuggestionResponseDto(locationsRequest.plantId, totalCases.status ? totalCases.data.cases : 0, totalCases.status ? totalCases.data.reportedCases : 0, location[0].zoneId, location[0].zoneName, location[0].rackPositionCode, location[0].rackPositionId, location[0].rackCode, location[0].occupancy);
                            response.push(rackSuggestionDto);
                            let newResponse;
                            if(locationsRequest.role === "WAREHOUSE INCHARGE"){
                                let availData = availableLocationData.filter((res) => res.rackPositionId != response[0].rackPositionId);
                                newResponse = [...response, ...availData];
                            }
                            else{
                                newResponse = response;
                            }
                           

                            // for(const rack of location){
                            //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                            return new CommonResponse(true, 10001, "Suggesting Location For SO", newResponse);
                            //     }
                            //     else{
                            //         return new CommonResponse(false, 1010, "No racks reserved for SO");
                            //     }

                            // }
                        }
                        else {
                            return new CommonResponse(false, 1010, "No racks reserved for SO");
                        }
                    }
                }
                else if (Number(locationsRequest.mastersCartons / palletCapacity) * 100 < 100) {
                    const rackPositions = 'select rack_reserve_code AS rackPositionCode, rack_position_id AS rackPositionId, rack_code AS rackCode, occupancy AS occupancy,zm.zone_id AS zoneId,zm.zone_name AS zoneName,SUM(st.total_cartons) AS totalCartons, st.pallet_capacity AS palletCapacity from ' + appSettings.masters_db + '.rack_position  LEFT JOIN zone_master zm on zm.zone_id = rack_position.zone_id LEFT JOIN ' + appSettings.warehouse_db + '.stock st ON st.location = rack_position.rack_position_id where rack_position.sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level = 1 and occupancy= "Assigned" and st.sale_order_item_id = ' + locationsRequest.saleOrderItemId + ' group by rack_position_id HAVING SUM(st.total_cartons) < st.pallet_capacity  AND SUM(st.total_cartons)+' + locationsRequest.mastersCartons + ' <= st.pallet_capacity ';
                    // and occupancy != "Assigned"' 
                    // and rack_reserve_code = (select MIN(rack_reserve_code) from '+appSettings.masters_db+'.rack_position where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id='+locationsRequest.plantId + ' and rack_level = 1 and occupancy != "Assigned")';
                    console.log('getLocationForSo' + rackPositions);
                    location = await connection.query(rackPositions);
                    console.log("location.length" + location.length)
                    if (location.length > 0 && location[0].rackPositionCode != null && locationsRequest.mastersCartons <= (location[0].palletCapacity - location[0].totalCartons)) {
                        // for(const rack of location){
                        //     console.log("rack rack"+rack.occupancy);
                        //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                        const totalCases = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                        const stock = await this.fGStockService.getStockQtyForSoAndSoItem({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                        console.log("ttttttttttttttt" + stock.data)
                        let response: RackSuggestionResponseDto[] = [];

                        const rackSuggestionDto = new RackSuggestionResponseDto(locationsRequest.plantId, totalCases.status ? totalCases.data.cases : 0, totalCases.status ? totalCases.data.reportedCases : 0, location[0].zoneId, location[0].zoneName, location[0].rackPositionCode, location[0].rackPositionId, location[0].rackCode, location[0].occupancy);
                        response.push(rackSuggestionDto);

                        let newResponse;
                        if(locationsRequest.role === "WAREHOUSE INCHARGE"){
                            let availData = availableLocationData.filter((res) => res.rackPositionId != response[0].rackPositionId);
                            newResponse = [...response, ...availData];
                        }
                        else{
                            newResponse = response;
                        }
                       

                        // for(const rack of location){
                        //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                        return new CommonResponse(true, 10001, "Suggesting Location For SO", newResponse);
                        //     }
                        //     else{
                        //         return new CommonResponse(false, 1010, "No racks reserved for SO");
                        //     }
                        // }

                    }
                    else {
                        const rackPositions = 'select rack_reserve_code AS rackPositionCode, rack_position_id AS rackPositionId, rack_code AS rackCode, occupancy AS occupancy,zm.zone_id AS zoneId,zm.zone_name AS zoneName from ' + appSettings.masters_db + '.rack_position  LEFT JOIN zone_master zm on zm.zone_id = rack_position.zone_id where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level = 1 and occupancy != "Assigned" and rack_reserve_code = (select MIN(rack_reserve_code) from ' + appSettings.masters_db + '.rack_position where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level = 1 and occupancy != "Assigned")';
                        console.log('getLocationForSo' + rackPositions);
                        location = await connection.query(rackPositions);
                        console.log("location.length" + location.length)
                        if (location.length > 0 && location[0].rackPositionCode != null) {
                            // for(const rack of location){
                            //     console.log("rack rack"+rack.occupancy);
                            //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                            const totalCases = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                            const stock = await this.fGStockService.getStockQtyForSoAndSoItem({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                            console.log("ttttttttttttttt" + stock.data)
                            let response: RackSuggestionResponseDto[] = [];

                            const rackSuggestionDto = new RackSuggestionResponseDto(locationsRequest.plantId, totalCases.status ? totalCases.data.cases : 0, totalCases.status ? totalCases.data.reportedCases : 0, location[0].zoneId, location[0].zoneName, location[0].rackPositionCode, location[0].rackPositionId, location[0].rackCode, location[0].occupancy);
                            response.push(rackSuggestionDto);
                            let newResponse;
                            if(locationsRequest.role === "WAREHOUSE INCHARGE"){
                                let availData = availableLocationData.filter((res) => res.rackPositionId != response[0].rackPositionId);
                                newResponse = [...response, ...availData];
                            }
                            else{
                                newResponse = response;
                            }
                        

                            // for(const rack of location){
                            //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                            return new CommonResponse(true, 10001, "Suggesting Location For SO", newResponse);
                            //     }
                            //     else{
                            //         return new CommonResponse(false, 1010, "No racks reserved for SO");
                            //     }
                            // }

                        }
                        else {
                            const rackPositions = 'select rack_reserve_code AS rackPositionCode, rack_position_id AS rackPositionId, rack_code AS rackCode, occupancy AS occupancy,zm.zone_id AS zoneId,zm.zone_name AS zoneName from ' + appSettings.masters_db + '.rack_position LEFT JOIN zone_master zm on zm.zone_id = rack_position.zone_id where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level != (select MAX(level_code) from erpx_dev_masters.level) and occupancy != "Assigned" and rack_reserve_code = (select MIN(rack_reserve_code) from ' + appSettings.masters_db + '.rack_position where sale_order_id =' + locationsRequest.saleOrderId + ' and rack_position.plant_id=' + locationsRequest.plantId + ' and rack_level != (select MAX(level_code) from erpx_dev_masters.level) and occupancy != "Assigned")';
                            console.log('getLocationForSo' + rackPositions);
                            location = await connection.query(rackPositions);
                            console.log("location.length" + location.length)
                            if (location.length > 0 && location[0].rackPositionCode != null) {
                                // for(const rack of location){
                                //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                                const totalCases = await this.saleOrderService.getSaleOrderItemDetails({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                                const stock = await this.fGStockService.getStockQtyForSoAndSoItem({ saleOrderId: locationsRequest.saleOrderId, saleOrderItemId: locationsRequest.saleOrderItemId });
                                console.log("oooooooooooooooo" + stock.data)
                                let response: RackSuggestionResponseDto[] = [];

                                const rackSuggestionDto = new RackSuggestionResponseDto(locationsRequest.plantId, totalCases.status ? totalCases.data.cases : 0, totalCases.status ? totalCases.data.reportedCases : 0, location[0].zoneId, location[0].zoneName, location[0].rackPositionCode, location[0].rackPositionId, location[0].rackCode, location[0].occupancy);
                                response.push(rackSuggestionDto);
                                let newResponse;
                                if(locationsRequest.role === "WAREHOUSE INCHARGE"){
                                    let availData = availableLocationData.filter((res) => res.rackPositionId != response[0].rackPositionId);
                                    newResponse = [...response, ...availData];
                                }
                                else{
                                    newResponse = response;
                                }
                            

                                // for(const rack of location){
                                //     if(rack.occupancy == OccupancyEnum.NOT_OCCUPIED){
                                return new CommonResponse(true, 10001, "Suggesting Location For SO", newResponse);
                                //     }
                                //     else{
                                //         return new CommonResponse(false, 1010, "No racks reserved for SO");
                                //     }
                                // }
                            }
                            else {
                                return new CommonResponse(false, 1010, "No racks reserved for SO");
                            }
                        }
                    }
                }
                // }
                // else{
                //     const reserveLocations = await this.reserveRackPositions({saleOrderId:locationsRequest.saleOrderId,stockTypeStatus:locationsRequest.stockTypeStatus});
                //     if(reserveLocations != undefined){
                //         return new CommonResponse(true,10001,"Locations reserved for SO, please try again.");
                //     }
                // }
            }
        }
        catch (error) {
            return error
        }
    }
    async getUnreserveRackPositions(req: SoIdRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction()
            const rackStatus = await this.rackRepository.update({ saleOrderId: req.saleOrderId }, { isReserved: false, saleOrderId: null, varientId: null, reservedDate: null });
            if (rackStatus.affected > 0) {
                manager.completeTransaction();
                return new CommonResponse(true, 1001, "Rack Unreserved successfully. ",);
            }
            else {
                await manager.releaseTransaction()
                return new CommonResponse(false, 1010, "Something went wrong. ",);
            }

        } catch (err) {
            await manager.releaseTransaction();
            throw err
        }
    }
    async getRackPositionsForDummy(req: DummyRackRequest): Promise<CommonResponse> {
        try {
            const dummyRacks = await this.rackRepository.find({
                select: ['rackPositionId', 'rackCode', 'rackPositionCode'],
                where: { plantId: req.plantId, varientId: req.varientId },
                order: { rackPositionCode: "ASC" }
            });
            console.log(dummyRacks);
            return new CommonResponse(true, 1001, "", dummyRacks);
        }
        catch (err) {
            throw err
        }
    }
    async getRackStatus(req: RackStatusRequest): Promise<CommonResponse> {
        try {
            const connection = getManager();
            let rackPositions = 'select rack_id AS rackId,occupancy,COUNT(*) AS cnt from ' + appSettings.masters_db + '.rack_position where zone_id = ' + req.zoneId + ' and is_active = true';
            if (req.plantId != 5) {
                rackPositions = rackPositions + ' and rack_position.plant_id=' + req.plantId;
            }
            rackPositions = rackPositions + ' GROUP BY rack_id , occupancy ORDER BY rack_id ASC';
            let location = await connection.query(rackPositions);
            console.log(location)
            if (location.length > 0) {
                return new CommonResponse(true, 1001, "Racks Status retrived Successfully. ", location);
            }
            else {
                return new CommonResponse(false, 1010, "No data found. ",);
            }
        }
        catch (err) {
            throw err
        }
    }

    async getUnit1RackPositions(plantIdRequest: PlantIdRequest): Promise<any> {
        try {
            const getRackPositions = await this.rackRepository.find({
                where: { plantId: plantIdRequest.plantId, isActive: true },
                order: { rackReserveCode: "ASC" }
            });
            if (getRackPositions.length > 0) {
                return new CommonResponse(true, 1001, "Rack positions retrived successfully. ", getRackPositions);
            }
            else {
                return new CommonResponse(false, 1010, "Racks not found. ");
            }
        }
        catch (err) {
            throw err
        }
    }

    async updateOccupancyAfterTransfer(rackPostionRequest: RackPostionReq): Promise<CommonResponse> {
        let occupancy;
        const isReservedStaus = await this.rackRepository.findOne({
            select: ['rackPositionId', 'isReserved', 'occupancy'],
            where: { rackPositionId: rackPostionRequest.rackPositionId },
        })
        // if (!isReservedStaus) {
        //     // if(isReservedStaus.isReserved == true){
        //     //     occupancy = OccupancyEnum.OCCUPIED
        //     // }else{
        //     occupancy = OccupancyEnum.NOT_OCCUPIED;
        //     // }
        // }
        // else{
        //     occupancy = isReservedStaus.occupancy;
        // }
        const updateOldRackPosition = await this.rackRepository.update({ rackPositionId: rackPostionRequest.rackPositionId }, { occupancy: rackPostionRequest.occupancy, saleOrderId: 0, isReserved: false })
        const updateNewRackPostion = await this.rackRepository.update({ rackPositionId: rackPostionRequest.newRackPositionId }, { saleOrderId: rackPostionRequest.saleOrderId, occupancy: OccupancyEnum.ASSIGNED, isReserved: true });
        console.log(updateOldRackPosition.raw, updateNewRackPostion.raw)
        if (updateOldRackPosition.affected && updateNewRackPostion.affected) {
            return new CommonResponse(true, 1001, 'rack position updated succesfully. ', updateOldRackPosition.affected)
        }
        else {
            return new CommonResponse(false, 10000, 'Rack Details not found', updateOldRackPosition.affected);
        }
    }

    async reReserveRackPositions(locationsRequired:number,plantId:number,dummyStatus:boolean,saleOrderId:number,saleOrderItemId:number,reservePercentage:number):Promise<CommonResponse>{
        const connection = getManager();
        //get % of locations
        let saleOrdersQuery = `SELECT si.sale_order_id,SUM(si.job_cases) AS required,SUM(si.reported_cases) AS reported_cases,ROUND((SUM(si.reported_cases)/SUM(si.job_cases))*100,0) AS occupied,s.stock_reported_date,s.reserved_per,rp.rack_id FROM `+appSettings.sales_db+`.sale_order_items si LEFT JOIN `+appSettings.masters_db+`.rack_position rp ON rp.sale_order_id=si.sale_order_id AND rp.rack_position_id = (SELECT MAX(rack_position_id) FROM `+appSettings.masters_db+`.rack_position rp 
        WHERE rp.sale_order_id = si.sale_order_id) LEFT JOIN `+appSettings.sales_db+`.sale_order so ON so.sale_order_id=si.sale_order_id LEFT JOIN `+appSettings.sales_db+`.so_invoice_details s ON s.sale_order_id=si.sale_order_id WHERE rp.plant_id = `+plantId+` and reported_cases>0 and so.status IN ("Open","Inprogress") GROUP BY sale_order_id HAVING occupied <`+reservePercentage+` ORDER BY s.reserved_per DESC , s.stock_reported_date ASC `;

        console.log(saleOrdersQuery);
        const saleOrderResult = await connection.query(saleOrdersQuery);
        console.log("saleOrderResult Length" +saleOrderResult)
        console.log("saleOrderResult Length" +saleOrderResult.length)
        if(saleOrderResult.length>0){
            // let result = saleOrderResult.map(a => a.sale_order_id);
           for(const saleOrders of saleOrderResult){
               console.log(saleOrders.stock_reported_date)

               if(saleOrders.stock_reported_date != null){
                    const saleOrderIdReserved=saleOrders.sale_order_id;
                    //get the 
                    let locationsAvailableQuery=`select count(*) as cnt,max(rack_reserve_code) as rack_position_code, rack_id as rackId from `+appSettings.masters_db+`.rack_position where sale_order_id=`+saleOrderIdReserved+` and is_reserved=1 and is_active = true and occupancy='Occupied'`;
                    let locationsAvailableResult= await connection.query(locationsAvailableQuery);
                    console.log('locationsAvailableQuery');
                    console.log(locationsAvailableQuery)
                    console.log(locationsAvailableResult.length)
                    let palletsRequired = locationsAvailableResult[0].cnt;
                    const positionsRequired= palletsRequired % 2 === 0?Math.ceil(palletsRequired):Math.ceil(palletsRequired-1);
                    console.log("positionsRequired"+positionsRequired);
                    if(positionsRequired > 0){
                        let halfPositions = Math.ceil(positionsRequired)
                        if(positionsRequired > 2){
                            halfPositions= Math.ceil(positionsRequired/2);
                        }
                        const palletsRequired= halfPositions % 2 === 0?Math.ceil(halfPositions):Math.ceil(halfPositions-1);
                        console.log(palletsRequired);
                        let positionsResult = await this.rackService.getRereserveRackPositions({plantId:plantId,positions:palletsRequired,saleOrderId:saleOrderIdReserved});
                        console.log(positionsResult);
                        if(positionsResult.first_number != undefined){
                            let maxRack = positionsResult.last_number % 2 === 0?Math.ceil(positionsResult.last_number):Math.ceil(positionsResult.last_number) - Number(1);
                            let minRack = Number(maxRack) - Number(palletsRequired) + Number(1);
                            console.log("minRack"+minRack);
                            console.log("maxRack"+maxRack);
                            if(Number(minRack) >= Number(positionsResult.first_number)){
                                console.log(maxRack+"**"+positionsRequired)
                                let updateRackPosition='update '+appSettings.masters_db+'.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id='+saleOrderId+',sale_order_item_id = '+saleOrderItemId+',reserved_date=now() where rack_reserve_code between '+minRack+' and '+maxRack;
                                console.log(updateRackPosition);
                                let updateResult=await connection.query(updateRackPosition);
                                console.log("updateResult"+updateResult);
                                let getReservedRacksCount = 'select count(*) as cnt from '+appSettings.masters_db+'.rack_position where sale_order_id = '+saleOrderIdReserved+' and sale_order_item_id = '+ saleOrderItemId+' and occupancy IN ("Occupied","Assigned")';
                                let reservedCount = await connection.query(getReservedRacksCount);
                                console.log(reservedCount[0].cnt);
                                console.log(palletsRequired);
                                let palletsRequiredDetails = await this.saleOrderService.getNoOfRackPositionsForSO({saleOrderId:saleOrderIdReserved});
                                    let palletsRequiredforSo = palletsRequiredDetails.data?palletsRequiredDetails.data:0;
                                let reservePer = Math.ceil((reservedCount[0].cnt/palletsRequiredforSo)*100);
                                console.log("reservePer" + reservePer)
                                let updatedReservedPer = 'update '+appSettings.sales_db+'.so_invoice_details set reserved_per ='+reservePer+' where sale_order_id = '+saleOrderIdReserved;
                                let reserveStatus = await connection.query(updatedReservedPer);

                                let getNewReservedRacksCount = 'select count(*) as cnt from '+appSettings.masters_db+'.rack_position where sale_order_id = '+saleOrderId+' and sale_order_item_id = '+saleOrderItemId+' and occupancy IN ("Occupied","Assigned")';
                                let newReservedCount = await connection.query(getNewReservedRacksCount);
                                console.log(newReservedCount[0].cnt);
                                console.log(palletsRequired);
                                let newPalletsRequiredDetails = await this.saleOrderService.getNoOfRackPositionsForSO({saleOrderId:saleOrderId});
                                    let newPalletsRequiredforSo = newPalletsRequiredDetails.data?newPalletsRequiredDetails.data:0;
                                let newReservePer = Math.ceil((newReservedCount[0].cnt/newPalletsRequiredforSo)*100);
                                console.log("newReservePer" + newReservePer)
                                let newUpdatedReservedPer = 'update '+appSettings.sales_db+'.so_invoice_details set reserved_per ='+newReservePer+' where sale_order_id = '+saleOrderId;
                                let newreserveStatus = await connection.query(newUpdatedReservedPer);


                                let getreservedInfo = 'select COUNT(*) AS cnt,MIN(rack_code) AS fromRack,MAX(rack_code) AS toRack from '+appSettings.masters_db+'.rack_position where sale_order_id='+saleOrderId+' and sale_order_item_id = '+saleOrderItemId+' and rack_reserve_code between '+minRack+' and '+maxRack;
                                let reservedRacks=await connection.query(getreservedInfo);
                                let reserveMsg = "Reserved "+reservedRacks[0].cnt+" Positions from "+reservedRacks[0].fromRack + " to "+ reservedRacks[0].toRack;

                                

                                console.log(updatedReservedPer);
                                console.log(reserveStatus);
                                console.log(updateRackPosition);
                                console.log(updateResult.affectedRows);

                                if(updateResult.affectedRows>0){
                                    return new CommonResponse(true, 1001, "Reserved rack positions successfully", reserveMsg);
                                    // return true;
                                }
                                else{
                                    return new CommonResponse(false, 1001, "Something went wrong", reserveMsg);
                                    // return false;
                                }
                            }
                            else{
                                return new CommonResponse(false, 1001, "Something went wrong");
                                // return false;
                            }
                        }
                    }
                }
           }
            //reserve location for the above sale order
        }else{
            // console.log('Reported Stock not found. ')
            return new CommonResponse(false, 1001, "Reported Stock not found.");
            // return false;
        }
        // return true;
    }
    async reserveRacksForIssuedQty(rackSuggestionRequest: ReserveRacksPostionsRequest):Promise<CommonResponse>{
        console.log(rackSuggestionRequest);
        try{

            const connection = getManager();
            let palletCapacityQuery = "Select max_pallet_capacity AS maxPalletCapacity from "+appSettings.masters_db+".packing_methods pm where pm.packing_method_id = "+rackSuggestionRequest.packStyleId;
            const palletCapacity = await connection.query(palletCapacityQuery);

            console.log(rackSuggestionRequest.stockTypeStatus);
            if(rackSuggestionRequest.stockTypeStatus=="dummy"){
                console.log("Dummy Suggestions")
                const suggestRackPosition = await this.getSuggestLocation({plantId:rackSuggestionRequest.plantId,saleOrderId:rackSuggestionRequest.saleOrderId,saleOrderItemId:rackSuggestionRequest.saleOrderItemId,mastersCartons:palletCapacity[0].maxPalletCapacity,stockTypeStatus:rackSuggestionRequest.stockTypeStatus,varientId:rackSuggestionRequest.varientId});
                if(suggestRackPosition.status){
                    return new CommonResponse(suggestRackPosition.status, suggestRackPosition.intlCode, suggestRackPosition.internalMessage, suggestRackPosition.data);
                }
                else{
                    return new CommonResponse(suggestRackPosition.status, suggestRackPosition.intlCode, suggestRackPosition.internalMessage, suggestRackPosition.data);
                }
            }
            else
            {
                const checkPositionsReserved = 'select count(*) as cnt from '+appSettings.masters_db+'.rack_position where sale_order_id='+rackSuggestionRequest.saleOrderId+' and sale_order_item_id = '+rackSuggestionRequest.saleOrderItemId +' and occupancy = "' + OccupancyEnum.OCCUPIED + '"';
                const reservedPalletsCount = await connection.query(checkPositionsReserved);
                if(reservedPalletsCount[0].cnt > 0){
                    const suggestRackPosition = await this.getSuggestLocation({plantId:rackSuggestionRequest.plantId,saleOrderId:rackSuggestionRequest.saleOrderId,saleOrderItemId:rackSuggestionRequest.saleOrderItemId,mastersCartons:palletCapacity[0].maxPalletCapacity,stockTypeStatus:rackSuggestionRequest.stockTypeStatus});
                    console.log(suggestRackPosition.status);
                    if(suggestRackPosition.status){
                        return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                    }
                }
                else{
                    let palletsRequired = 0;
                    palletsRequired = Math.abs(rackSuggestionRequest.issuedCases);
                    console.log("palletsRequired palletsRequired" + palletsRequired);
                    const positionsRequired= palletsRequired % 2 === 0?Math.ceil(palletsRequired):Math.ceil(palletsRequired+1);
                    console.log("positionsRequired"+positionsRequired)
                    const getCount = await this.rackService.getRackPositionsCount({plantId:rackSuggestionRequest.plantId,positions:positionsRequired});
                    console.log(getCount.first_number);
                    let minRack = getCount.first_number % 2 === 0?Math.ceil(getCount.first_number)+Number(1):Math.ceil(getCount.first_number);
                    let maxRack = Number(minRack) + Number(positionsRequired) - 1;
                    let calAvailPer = Math.ceil((Number(getCount.positions)/Number(positionsRequired))* 100);
                    console.log("calAvailPer" + calAvailPer);
                    if(getCount.first_number != undefined){
                        if(calAvailPer >= 25){
                            if(Number(maxRack) <= Number(getCount.last_number)){
                                console.log(maxRack+"**"+positionsRequired)
                                let updateRackPosition='update '+appSettings.masters_db+'.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id='+rackSuggestionRequest.saleOrderId+',sale_order_item_id = '+rackSuggestionRequest.saleOrderItemId+',reserved_date=now() where rack_reserve_code between '+minRack+' and '+maxRack;
                                console.log(updateRackPosition);
                                let updateResult=await connection.query(updateRackPosition);
                                console.log("updateResult"+updateResult);
                                let getReservedRacksCount = 'select count(*) as cnt from '+appSettings.masters_db+'.rack_position where sale_order_id = '+rackSuggestionRequest.saleOrderId+' and sale_order_item_id = '+rackSuggestionRequest.saleOrderItemId+'  and occupancy IN ("Occupied","Assigned")';
                                let reservedCount = await connection.query(getReservedRacksCount);
                                console.log(reservedCount[0].cnt);
                                console.log(palletsRequired);
                                let reservePer = Math.ceil((reservedCount[0].cnt/positionsRequired)*100);
                                console.log("reservePer" + reservePer)
                                let updatedReservedPer = 'update '+appSettings.sales_db+'.so_invoice_details set reserved_per ='+reservePer+' where sale_order_id = '+rackSuggestionRequest.saleOrderId;
                                let reserveStatus = await connection.query(updatedReservedPer);
                                console.log(updatedReservedPer);
                                console.log(reserveStatus);
                                console.log(updateRackPosition);
                                console.log(updateResult.affectedRows);
                                let getreservedInfo = 'select COUNT(*) AS cnt,MIN(rack_code) AS fromRack,MAX(rack_code) AS toRack from '+appSettings.masters_db+'.rack_position where sale_order_id='+rackSuggestionRequest.saleOrderId+' and sale_order_item_id = '+rackSuggestionRequest.saleOrderItemId+' and rack_reserve_code between '+minRack+' and '+maxRack;
                                let reservedRacks=await connection.query(getreservedInfo);
                                let reserveMsg = "Reserved "+reservedRacks[0].cnt+" Positions from "+reservedRacks[0].fromRack + " to "+ reservedRacks[0].toRack;
                                if(updateResult.affectedRows>0){
                                    const suggestRackPosition = await this.getSuggestLocation({plantId:rackSuggestionRequest.plantId,saleOrderId:rackSuggestionRequest.saleOrderId,saleOrderItemId:rackSuggestionRequest.saleOrderItemId,mastersCartons:palletCapacity[0].maxPalletCapacity,stockTypeStatus:rackSuggestionRequest.stockTypeStatus});
                                    console.log(suggestRackPosition.status);
                                    if(suggestRackPosition.status){
                                        return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data,reserveMsg);
                                    }
                                }
                            }
                            else{
                                let updateRackPosition='update '+appSettings.masters_db+'.rack_position set is_reserved=1,occupancy= "Occupied",sale_order_id='+rackSuggestionRequest.saleOrderId+',sale_order_item_id = '+rackSuggestionRequest.saleOrderItemId+',reserved_date=now() where rack_reserve_code between '+minRack+' and '+getCount.last_number;
                                console.log(updateRackPosition);
                                let updateResult=await connection.query(updateRackPosition);
                                console.log("updateResult"+updateResult);
                                let getReservedRacksCount = 'select count(*) as cnt from '+appSettings.masters_db+'.rack_position where sale_order_id = '+rackSuggestionRequest.saleOrderId+' and sale_order_item_id = '+rackSuggestionRequest.saleOrderItemId+' and occupancy IN ("Occupied","Assigned")';
                                let reservedCount = await connection.query(getReservedRacksCount);
                                console.log(reservedCount[0].cnt);
                                console.log(palletsRequired);
                                let reservePer = Math.ceil((reservedCount[0].cnt/getCount.positions)*100);
                                console.log("reservePer" + reservePer)
                                let updatedReservedPer = 'update '+appSettings.sales_db+'.so_invoice_details set reserved_per ='+reservePer+' where sale_order_id = '+rackSuggestionRequest.saleOrderId;
                                let reserveStatus = await connection.query(updatedReservedPer);
                                console.log(updatedReservedPer);
                                console.log(reserveStatus);
                                console.log(updateRackPosition);
                                console.log(updateResult.affectedRows);
                                let getreservedInfo = 'select COUNT(*) AS cnt,MIN(rack_code) AS fromRack,MAX(rack_code) AS toRack from '+appSettings.masters_db+'.rack_position where sale_order_id='+rackSuggestionRequest.saleOrderId+' and sale_order_item_id = '+rackSuggestionRequest.saleOrderItemId+' and rack_reserve_code between '+minRack+' and '+maxRack;
                                let reservedRacks=await connection.query(getreservedInfo);
                                let reserveMsg = "Reserved "+reservedRacks[0].cnt+" Positions from "+reservedRacks[0].fromRack + " to "+ reservedRacks[0].toRack;
                                if(updateResult.affectedRows>0){
                                    const suggestRackPosition = await this.getSuggestLocation({plantId:rackSuggestionRequest.plantId,saleOrderId:rackSuggestionRequest.saleOrderId,saleOrderItemId:rackSuggestionRequest.saleOrderItemId,mastersCartons:palletCapacity[0].maxPalletCapacity,stockTypeStatus:rackSuggestionRequest.stockTypeStatus});
                                    console.log(suggestRackPosition.status);
                                    if(suggestRackPosition.status){
                                        return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data,reserveMsg);
                                    }
                                }
                            }
                        }
                        else{
                            // rereserve logic
                            let availabilityResult  = await this.reReserveRackPositions(Math.ceil(palletsRequired),rackSuggestionRequest.plantId,false,rackSuggestionRequest.saleOrderId,rackSuggestionRequest.saleOrderItemId,50);
                            if(availabilityResult.status){
                                console.log('success');
                                const suggestRackPosition = await this.getSuggestLocation({plantId:rackSuggestionRequest.plantId,saleOrderId:rackSuggestionRequest.saleOrderId,saleOrderItemId:rackSuggestionRequest.saleOrderItemId,mastersCartons:palletCapacity[0].maxPalletCapacity,stockTypeStatus:rackSuggestionRequest.stockTypeStatus});
                                if(suggestRackPosition.status){
                                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", suggestRackPosition.data);
                                }
                            }
                            else{
                                return new CommonResponse(false, 1010, "No racks available. ");
                            }
                        }
                    }
                    else{
                        return new CommonResponse(false, 1010, "Something went wrong. ");
                    }
                }
            }
        }
        catch (err) {
            console.log(err);
            throw err
        }
    }

    async getRackSuggestion(req: RackSuggestionRequestDto):Promise<CommonResponse>{
        const connection = getManager();
        try{
            const reservedPlaceList = await connection.query("select * from "+appSettings.procure_db+".place_list_items pli left join "+appSettings.procure_db+".store_consumption sc on sc.store_consumption_id = pli.store_consumption_id where pli.store_consumption_id IN("+req.storeConsumptionId+") and pli.occupancy != 'Assigned' order by pli.store_consumption_id ASC");
            let getRackDetails;
            if(req.reportingCases >0 ){
                if(req.reportingCases <= reservedPlaceList[0].pallet_capacity){
                    getRackDetails = await connection.query("select * from "+appSettings.procure_db+".place_list_items pli where pli.store_consumption_id IN("+req.storeConsumptionId+") and pli.occupancy != 'Assigned' order by pli.store_consumption_id, pli.rack_reserve_code ASC limit 1");
                }
                else if(req.reportingCases > reservedPlaceList[0].pallet_capacity){
                    getRackDetails = await connection.query("select * from "+appSettings.procure_db+".place_list_items pli where pli.store_consumption_id IN("+req.storeConsumptionId+") and pli.occupancy != 'Assigned' order by pli.store_consumption_id, pli.rack_reserve_code DESC limit 1");
                }
                if(getRackDetails.length > 0){
                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", getRackDetails);
                }
                else{
                    return new CommonResponse(false, 1011, "No rack found, please generate pick list ",);
                }
            }
            else{
                getRackDetails = await connection.query("select * from "+appSettings.procure_db+".place_list_items pli where pli.store_consumption_id IN("+req.storeConsumptionId+") and pli.occupancy != 'Assigned' order by pli.store_consumption_id, pli.rack_reserve_code ASC limit 1");
                if(getRackDetails.length > 0){
                    return new CommonResponse(true, 1001, "Rack Positions retrived successfully", getRackDetails);
                }
                else{
                    return new CommonResponse(false, 1011, "No rack found, please generate pick list ",);
                }
            }
        }
        catch (err) {
            return new CommonResponse(false, 1011, "something went wrong. ",err);
        }
    }

    async getRackDetailsById(req: RackPositionId):Promise<CommonResponse>{
        try{
            let query = await this.rackRepository.findOne({where:{rackPositionId:req.rackPositionId}});
            if(query.rackPositionId > 0){
                return new CommonResponse(true,1001,"Rack Details retrived Successfully. ", query);
            }
            else{
                return new CommonResponse(false, 1011, "something went wrong. ",query);
            }
        }catch (err) {
            return new CommonResponse(false, 1011, "something went wrong. ",err);
        }
    }
    async getNotOccupiedLocationsForPlant(req: PlantIdRequest): Promise<CommonResponse> {
        try{
            const manager = getManager();
            let query = "Select rp.rack_position_id AS rackPositionId, rp.rack_code AS rackCode from "+appSettings.masters_db+".rack_position rp where rp.plant_id = "+req.plantId+" and occupancy = 'Not Occupied' and rp.is_active = true order by rp.rack_code ASC";
            let result = await manager.query(query);
            if(result.length > 0){
                return new CommonResponse(true,1011,"Rack positions retrived successfully. ", result);
            }
            else{
                return new CommonResponse(false,1010,"No data found. ");
            }
        }
        catch(err){
            throw err
        }
    }

}
